<template>
  <table cellspacing="0" cellpadding="0">
    <tr>
      <th rowspan="2" class="th-green"></th>
      <th colspan="3" class="th-green th-boild" style="white-space: nowrap;text-align:center">
        Thông tin khách hàng
      </th>
      <th colspan="7" class="th-yellow th-boild" style="text-align:center">Bài kiểm tra</th>
      <th colspan="2" class="th-blue th-boild" style="text-align:center">Chuyển đổi</th>
      <!-- <th rowspan="2" class="th-boild">Tác nghiệp</th> -->
    </tr>
    <tr>
      <th class="th-green th-boild" style="white-space: nowrap">Tên phụ huynh</th>
      <th class="th-green th-boild" style="text-align:center">SĐT</th>
      <th class="th-green th-boild" style="white-space: nowrap;text-align:center;padding:12px 32px">Tên con</th>
      <th class="th-orange th-boild space-row" style="text-align:center;width:115px;padding:12px 26px;white-space: nowrap;">Môn học</th>
      <th class="th-orange th-boild" style="text-align:center;width:115px">Trạng thái</th>
      <th class="th-yellow th-boild" style="text-align:center;width:200px;padding:12px 60px;white-space: nowrap">Hẹn lịch</th>
      <th class="th-yellow th-boild" style="text-align:center;width:150px">Phỏng vấn</th>
      <th class="th-yellow th-boild" style="text-align:center">Đề thi</th>
      <th class="th-yellow th-boild" style="text-align:center;padding:12px 60px;white-space: nowrap">Kết quả</th>
      <th class="th-yellow th-boild" style="text-align:center;padding:12px 60px;white-space: nowrap">Nhận xét</th>
      <th class="th-blue th-boild" style="text-align:center;width:100px">Đơn hàng</th>
      <th class="th-blue th-boild" style="white-space: nowrap;width:100px">Trạng thái</th>
    </tr>
    <template v-for="listTutor in listTutors">
      <template v-if="listTutor.contactTutorPractice.length > 1">
        <tr>
          <th
              :rowspan="listTutor.contactTutorPractice.length"
              style="padding: 0 4px;text-align:center"
          >
            <input type="checkbox"/>
          </th>
        
          <th :rowspan="listTutor.contactTutorPractice.length" class="space-row">
            {{ listTutor.parentName }}
          </th>
          <th :rowspan="listTutor.contactTutorPractice.length"  class="space-row">
            {{ listTutor.mobile }}
          </th>
          <th :rowspan="listTutor.contactTutorPractice.length">
            {{ listTutor.userName }}
          </th>
          <th class="th-yellow" style="white-space: nowrap;">
            {{ getSubjectName(listTutor.contactTutorPractice[0].subjectId) }}
          </th>
          <th
              class="th-yellow d-flex align-center"
              :style="
              `height: 57px;
              border-right: none;
              border-top: none;
              `
            "
          >
            <div
                v-if="listTutor.contactTutorPractice[0].status == 0"
                style="white-space: nowrap; margin-top: 8px"
            >
              <svg
                  style="margin-right: 8px"
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M4 6.75C4.4 6.75 4.75 7.1 4.75 7.5C4.75 7.9 4.4 8.25 4 8.25C3.6 8.25 3.25 7.9 3.25 7.5C3.25 7.1 3.6 6.75 4 6.75ZM10.5 7H6.5C6.2 7 6 7.2 6 7.5C6 7.8 6.2 8 6.5 8H10.5C10.8 8 11 7.8 11 7.5C11 7.2 10.8 7 10.5 7ZM10.5 10H6.5C6.2 10 6 10.2 6 10.5C6 10.8 6.2 11 6.5 11H10.5C10.8 11 11 10.8 11 10.5C11 10.2 10.8 10 10.5 10ZM4 9.75C4.4 9.75 4.75 10.1 4.75 10.5C4.75 10.9 4.4 11.25 4 11.25C3.6 11.25 3.25 10.9 3.25 10.5C3.25 10.1 3.6 9.75 4 9.75ZM11 1H9.9C9.7 0.4 9.15 0 8.5 0H5.5C4.85 0 4.3 0.4 4.1 1H3C1.35 1 0 2.35 0 4V13C0 14.65 1.35 16 3 16H11C12.65 16 14 14.65 14 13V4C14 2.35 12.65 1 11 1ZM5.5 1H8.5C8.8 1 9 1.2 9 1.5V2.5C9 2.8 8.8 3 8.5 3H5.5C5.2 3 5 2.8 5 2.5V1.5C5 1.2 5.2 1 5.5 1ZM13 13C13 14.1 12.1 15 11 15H3C1.9 15 1 14.1 1 13V4C1 2.9 1.9 2 3 2H4V2.5C4 3.35 4.65 4 5.5 4H8.5C9.35 4 10 3.35 10 2.5V2H11C12.1 2 13 2.9 13 4V13Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ Test</span
              >
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].status == 1"
                class="th-yellow"
                style="white-space: nowrap"
            >
              <svg
                  class="mr-2"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M7 8C9.2 8 11 6.2 11 4C11 1.8 9.2 0 7 0C4.8 0 3 1.8 3 4C3 6.2 4.8 8 7 8ZM7 1C8.65 1 10 2.35 10 4C10 5.65 8.65 7 7 7C5.35 7 4 5.65 4 4C4 2.35 5.35 1 7 1ZM13.5 11.9C13.2 11.9 13 12.1 13 12.4V14.5C13 14.8 13.2 15 13.5 15C13.8 15 14 14.8 14 14.5V12.4C14 12.1 13.8 11.9 13.5 11.9ZM11.1 9.5C11.1 9.2 10.9 9 10.6 9H3.4C1.5 9 0 10.5 0 12.4V14.5C0 14.8 0.2 15 0.5 15C0.8 15 1 14.8 1 14.5V12.4C1 11.1 2.1 10 3.4 10H10.6C10.9 10 11.1 9.8 11.1 9.5ZM13.9 9.1C13.7 8.9 13.4 8.9 13.2 9.1L9.15 13.15L7.8 11.8C7.6 11.6 7.3 11.6 7.1 11.8C6.9 12 6.9 12.3 7.1 12.5L8.8 14.2C8.9 14.3 9 14.35 9.15 14.35C9.3 14.35 9.4 14.3 9.5 14.2L13.9 9.8C14.1 9.6 14.1 9.3 13.9 9.1Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ Pv</span
              >
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].status == 2"
                class="th-yellow"
                style="white-space: nowrap"
            >
              <svg
                  class="mr-2"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M11 1V0.5C11 0.2 10.8 0 10.5 0C10.2 0 10 0.2 10 0.5V1H4V0.5C4 0.2 3.8 0 3.5 0C3.2 0 3 0.2 3 0.5V1C1.35 1 0 2.35 0 4V12C0 13.65 1.35 15 3 15H11C12.65 15 14 13.65 14 12V4C14 2.35 12.65 1 11 1ZM13 12C13 13.1 12.1 14 11 14H3C1.9 14 1 13.1 1 12V4C1 2.9 1.9 2 3 2V2.5C3 2.8 3.2 3 3.5 3C3.8 3 4 2.8 4 2.5V2H10V2.5C10 2.8 10.2 3 10.5 3C10.8 3 11 2.8 11 2.5V2C12.1 2 13 2.9 13 4V12ZM5 5H9.4V6.05L6.75 11H5.35L7.95 6.15H5V5Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ lịch hẹn</span
              >
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].status == 3"
                class="th-yellow"
                style="white-space: nowrap"
            >
              <svg
                  class="mr-2"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M4.09998 15C3.89998 15 3.74998 14.95 3.59998 14.85C3.34998 14.65 3.19998 14.35 3.24998 14L3.89998 10.1L1.04998 7.35C0.799984 7.1 0.749984 6.75 0.849984 6.45C0.949984 6.15 1.19998 5.9 1.54998 5.85L5.44998 5.3L7.19998 1.75C7.34998 1.45 7.64998 1.25 7.99998 1.25C8.34998 1.25 8.64998 1.45 8.79998 1.75L10.55 5.3L14.45 5.85C14.8 5.9 15.05 6.15 15.15 6.45C15.25 6.75 15.15 7.1 14.95 7.35L12.1 10.1L12.75 14C12.8 14.35 12.65 14.65 12.4 14.85C12.15 15.05 11.8 15.05 11.5 14.9L7.99998 13.05L4.49998 14.9C4.39998 15 4.24998 15 4.09998 15ZM7.99998 11.95L11.75 13.9L11.05 9.75L14.1 6.8L9.89998 6.2L7.99998 2.4L6.14998 6.2L1.94998 6.8L4.99998 9.75L4.29998 13.9L7.99998 11.95Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ Nx </span
              >
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].status == 5"
                class="th-yellow d-flex justify-center mr-2"
                style="white-space: nowrap"
            >
              <a :href="`${listTutor.contactTutorPractice[0].appointmentLink} ? 'listTutor.contactTutorPractice[0].appointmentLink' ? ''`"
               style="text-decoration: unset">
                <v-icon
                    color="#6F7782"
                    style="font-size: 16px; margin-right: 6px; color: #25e8c8"
                >mdi-checkbox-marked-circle
                </v-icon>
                <span class="font-weight-bold d-inline-block" v-if="listTutor.contactTutorPractice[0].appointmentLink" style="white-space: nowrap;color:blue;text-decoration: underline">
                Done
              </span>
                <span v-else class="font-weight-bold" style="white-space: nowrap">
                Done
              </span>

              </a>
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].status == null"
                class="th-yellow"
                style="font-weight: 700; white-space: nowrap"
            ></div>
          </th>
          <th v-if="listTutor.contactTutorPractice[0].appointmentTime">
            <div class="d-flex flex-column justity-start">
              <div
                  style="position: relative"
                  v-if="listTutor.contactTutorPractice[0].appointmentTime"
              >
                <strong class="ml-1">{{
                    appointmenTimeText(
                        listTutor.contactTutorPractice[0].appointmentTime
                    ).time
                  }}</strong>
                <span>
                  {{
                    appointmenTimeText(
                        listTutor.contactTutorPractice[0].appointmentTime
                    ).date
                  }}</span
                >
                <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    :return-value.sync="myDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        v-if="listTutor.contactTutorPractice[0].status != 5 "
                        icon
                        dark
                        height="24"
                        class="update-time-btn"
                        @click="
                        showTime(
                          listTutor.contactTutorPractice[0].appointmentTime
                        )
                      "
                        v-on="on"
                        v-bind="attrs"
                    >
                      <svg
                          style="position: absolute; right: 4px"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                              d="M8.5 12.0002H1.5C0.673 12.0002 0 11.3272 0 10.5002V3.50024C0 2.67324 0.673 2.00024 1.5 2.00024H5.5C5.7765 2.00024 6 2.22424 6 2.50024C6 2.77624 5.7765 3.00024 5.5 3.00024H1.5C1.224 3.00024 1 3.22474 1 3.50024V10.5002C1 10.7757 1.224 11.0002 1.5 11.0002H8.5C8.776 11.0002 9 10.7757 9 10.5002V6.50024C9 6.22424 9.2235 6.00024 9.5 6.00024C9.7765 6.00024 10 6.22424 10 6.50024V10.5002C10 11.3272 9.327 12.0002 8.5 12.0002Z"
                              fill="#607D8B"
                          />
                          <path
                              d="M8.64403 1.58929L4.68803 5.54529C4.65303 5.58029 4.62953 5.62479 4.61953 5.67279L4.26603 7.44079C4.24953 7.52279 4.27503 7.60779 4.33453 7.66679C4.38203 7.71429 4.44603 7.73979 4.51153 7.73979L4.56053 7.73479L6.32803 7.38129C6.37703 7.37179 6.42103 7.34779 6.45603 7.31279L10.412 3.35679L8.64403 1.58929Z"
                              fill="#42A5F5"
                          />
                          <path
                              d="M11.6339 0.365747C11.1464 -0.121753 10.3534 -0.121753 9.86644 0.365747L9.17444 1.05775L10.9419 2.82525L11.6339 2.13325C11.8699 1.89775 11.9999 1.58375 11.9999 1.24975C11.9999 0.915747 11.8699 0.601747 11.6339 0.365747Z"
                              fill="#42A5F5"
                          />
                          <path
                              d="M9.49994 6C9.22344 6 8.99994 6.224 8.99994 6.5V10.5C8.99994 10.7755 8.77594 11 8.49994 11H1.49994C1.36194 11 1.23694 10.944 1.14644 10.8535L0.439941 11.56C0.711441 11.832 1.08644 12 1.49994 12H8.49994C9.32694 12 9.99994 11.327 9.99994 10.5V6.5C9.99994 6.2235 9.77644 6 9.49994 6Z"
                              fill="#546D79"
                          />
                          <path
                              d="M9.52797 2.4726L4.33447 7.66609C4.38197 7.71359 4.44597 7.73909 4.51147 7.73909L4.56047 7.73409L6.32797 7.38059C6.37697 7.37109 6.42097 7.34709 6.45597 7.31209L10.412 3.35609L9.52797 2.4726Z"
                              fill="#3990D5"
                          />
                          <path
                              d="M11.634 0.36615L10.0585 1.94165L10.9425 2.82565L11.6345 2.13365C11.87 1.89815 12 1.58415 12 1.25015C12 0.91615 11.87 0.60215 11.634 0.36615Z"
                              fill="#3990D5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </v-btn>

                  </template>
                  <div class="time-update-clendar">
                    <DatetimePicker
                        dateIcon
                        timeIcon
                        v-model="myDate"
                        no-title
                        label="Lịch hẹn"
                        time-format="HH:mm:ss"
                        date-format="MM/dd/yyyy"
                        @input="updateAppointmentTime(listTutor.contactTutorPractice[0])"
                    >
                      <template slot="dateIcon">
                        <v-icon
                        >mdi-calendar-range
                        </v-icon
                        >
                      </template>
                      <template slot="timeIcon">
                        <v-icon
                        >mdi-clock-outline
                        </v-icon
                        >
                      </template>

                    </DatetimePicker>
                  </div>
                </v-menu>
              </div>
              <div v-else></div>
              <div v-if="listTutor.contactTutorPractice[0].status != 5" style="display:none">
                <small
                    class="small-text ml-1"
                    v-if="
                    timeUnitsBetween(
                      new Date(),
                      new Date(
                        listTutor.contactTutorPractice[0].appointmentTime
                      )
                    ).includes('Đã quá hạn')
                  "
                    style="color: red"
                >
                  {{
                    timeUnitsBetween(
                        new Date(),
                        new Date(
                            listTutor.contactTutorPractice[0].appointmentTime
                        )
                    )
                  }}</small
                >
                <small class="small-text ml-1" v-else style="color: rgb(130 130 130 / 52%);">{{
                    timeUnitsBetween(
                        new Date(),
                        new Date(listTutor.contactTutorPractice[0].appointmentTime)
                    )
                  }}</small>
              </div>
            </div>
          </th>
          <th v-else>
            <div class="d-flex justify-space-around align-center">
              <span style="color: #e0e0e0">Chưa chọn </span>
              <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  :return-value.sync="myDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      dark
                      height="24"
                      @click="
                      showTime(
                        listTutor.contactTutorPractice[0].appointmentTime
                      )
                    "
                      v-on="on"
                      v-bind="attrs"
                  >
                    <svg
                        style="position: absolute; right: 4px"
                        v-if="listTutor.contactTutorPractice[0].status != 5"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                            d="M8.5 12.0002H1.5C0.673 12.0002 0 11.3272 0 10.5002V3.50024C0 2.67324 0.673 2.00024 1.5 2.00024H5.5C5.7765 2.00024 6 2.22424 6 2.50024C6 2.77624 5.7765 3.00024 5.5 3.00024H1.5C1.224 3.00024 1 3.22474 1 3.50024V10.5002C1 10.7757 1.224 11.0002 1.5 11.0002H8.5C8.776 11.0002 9 10.7757 9 10.5002V6.50024C9 6.22424 9.2235 6.00024 9.5 6.00024C9.7765 6.00024 10 6.22424 10 6.50024V10.5002C10 11.3272 9.327 12.0002 8.5 12.0002Z"
                            fill="#607D8B"
                        />
                        <path
                            d="M8.64403 1.58929L4.68803 5.54529C4.65303 5.58029 4.62953 5.62479 4.61953 5.67279L4.26603 7.44079C4.24953 7.52279 4.27503 7.60779 4.33453 7.66679C4.38203 7.71429 4.44603 7.73979 4.51153 7.73979L4.56053 7.73479L6.32803 7.38129C6.37703 7.37179 6.42103 7.34779 6.45603 7.31279L10.412 3.35679L8.64403 1.58929Z"
                            fill="#42A5F5"
                        />
                        <path
                            d="M11.6339 0.365747C11.1464 -0.121753 10.3534 -0.121753 9.86644 0.365747L9.17444 1.05775L10.9419 2.82525L11.6339 2.13325C11.8699 1.89775 11.9999 1.58375 11.9999 1.24975C11.9999 0.915747 11.8699 0.601747 11.6339 0.365747Z"
                            fill="#42A5F5"
                        />
                        <path
                            d="M9.49994 6C9.22344 6 8.99994 6.224 8.99994 6.5V10.5C8.99994 10.7755 8.77594 11 8.49994 11H1.49994C1.36194 11 1.23694 10.944 1.14644 10.8535L0.439941 11.56C0.711441 11.832 1.08644 12 1.49994 12H8.49994C9.32694 12 9.99994 11.327 9.99994 10.5V6.5C9.99994 6.2235 9.77644 6 9.49994 6Z"
                            fill="#546D79"
                        />
                        <path
                            d="M9.52797 2.4726L4.33447 7.66609C4.38197 7.71359 4.44597 7.73909 4.51147 7.73909L4.56047 7.73409L6.32797 7.38059C6.37697 7.37109 6.42097 7.34709 6.45597 7.31209L10.412 3.35609L9.52797 2.4726Z"
                            fill="#3990D5"
                        />
                        <path
                            d="M11.634 0.36615L10.0585 1.94165L10.9425 2.82565L11.6345 2.13365C11.87 1.89815 12 1.58415 12 1.25015C12 0.91615 11.87 0.60215 11.634 0.36615Z"
                            fill="#3990D5"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="12" height="12" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </v-btn>
                </template>
                 <div class="time-update-clendar">
                <DatetimePicker
                    dateIcon
                    timeIcon
                    v-model="myDate"
                    no-title
                    label="Lịch hẹn"
                    time-format="HH:mm:ss"
                    date-format="MM/dd/yyyy"
                    @input="updateAppointmentTime(listTutor.contactTutorPractice[0])"
                >
                  <template slot="dateIcon">
                    <v-icon
                    >mdi-calendar-range
                    </v-icon
                    >
                  </template>
                  <template slot="timeIcon">
                    <v-icon
                    >mdi-clock-outline
                    </v-icon
                    >
                  </template>
                </DatetimePicker>
                 </div>
              </v-menu>
            </div>
          </th>

          <th
              v-if="listTutor.contactTutorPractice[0].subjectId != 1"
              style="white-space: nowrap;position:relative"
              :style="[listTutor.contactTutorPractice[0].interviewStatus == 2 ? {'padding':'0 12px'} : '']"
          >
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 0"
            >
              <div
                  class="d-flex justify-space-between flex-column"

              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="d-flex">
                    <svg
                        class="mr-2"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M8 0C8.32 0 8.53333 0.213333 8.53333 0.533333V2.66667C8.53333 2.98667 8.32 3.2 8 3.2C7.68 3.2 7.46667 2.98667 7.46667 2.66667V0.533333C7.46667 0.213333 7.68 0 8 0ZM8 12.8C8.32 12.8 8.53333 13.0133 8.53333 13.3333V15.4667C8.53333 15.7867 8.32 16 8 16C7.68 16 7.46667 15.7867 7.46667 15.4667V13.3333C7.46667 13.0133 7.68 12.8 8 12.8ZM12.8 8C12.8 7.68 13.0133 7.46667 13.3333 7.46667H15.4667C15.7867 7.46667 16 7.68 16 8C16 8.32 15.7867 8.53333 15.4667 8.53333H13.3333C13.0133 8.53333 12.8 8.32 12.8 8ZM0 8C0 7.68 0.213333 7.46667 0.533333 7.46667H2.66667C2.98667 7.46667 3.2 7.68 3.2 8C3.2 8.32 2.98667 8.53333 2.66667 8.53333H0.533333C0.213333 8.53333 0 8.32 0 8ZM13.6533 2.34667C13.8667 2.56 13.8667 2.88 13.6533 3.09333L12.16 4.58667C11.9467 4.8 11.6267 4.8 11.4133 4.58667C11.2 4.37333 11.2 4.05333 11.4133 3.84L12.9067 2.34667C13.12 2.13333 13.44 2.13333 13.6533 2.34667ZM4.58667 11.4133C4.8 11.6267 4.8 11.9467 4.58667 12.16L3.09333 13.6533C2.88 13.8667 2.56 13.8667 2.34667 13.6533C2.13333 13.44 2.13333 13.12 2.34667 12.9067L3.84 11.4133C4.05333 11.2 4.37333 11.2 4.58667 11.4133ZM11.4133 11.4133C11.6267 11.2 11.9467 11.2 12.16 11.4133L13.6533 12.9067C13.8667 13.12 13.8667 13.44 13.6533 13.6533C13.44 13.8667 13.12 13.8667 12.9067 13.6533L11.4133 12.16C11.2 11.9467 11.2 11.6267 11.4133 11.4133ZM2.34667 2.34667C2.56 2.13333 2.88 2.13333 3.09333 2.34667L4.58667 3.84C4.8 4.05333 4.8 4.37333 4.58667 4.58667C4.37333 4.8 4.05333 4.8 3.84 4.58667L2.34667 3.09333C2.13333 2.88 2.13333 2.56 2.34667 2.34667Z"
                          fill="#F2994A"
                      />
                    </svg>

                    <span class="font-weight-bold mr-2">Chờ Pv</span>
                  </div>
                  <v-dialog
                      :retain-focus="false"
                      max-width="800px"
                      v-model="listTutor.showPopup"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          dark
                          height="24"
                          width="41"
                          v-bind="attrs"
                          class="interview-btn"
                          v-on="on"
                          @click="
                          interviewPopup(listTutor.contactTutorPractice[0])
                        "
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <validation-observer ref="validator" v-slot="{ invalid }">
                        <v-card-title>
                          <span class="text-h5 mr-2 header-popup-interview"
                          >Thông tin phỏng vấn</span
                          >
                        </v-card-title>
                        <v-card-text>
                          <v-divider class="mb-5"></v-divider>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Người phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn người phỏng vấn"
                                >
                                  <v-combobox
                                      :items="listInterview"
                                      required
                                      :error-messages="errors"
                                      item-text="fullName"
                                      item-value="id"
                                      dense
                                      placeholder="--Chọn chuyên môn--"
                                      outlined
                                      v-model="filterInterview.interviewUserId"
                                  ></v-combobox>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Trạng thái phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn con"
                                >
                                  <v-select
                                      :items="allStatus.interviewStatus"
                                      class="mr-3"
                                      :error-messages="errors"
                                      item-value="value"
                                      item-text="text"
                                      placeholder="Chờ phỏng vấn"
                                      outlined
                                      dense
                                      v-model="filterInterview.interviewStatus"
                                  ></v-select>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" md="12">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Nhận xét
                                </label>
                                <v-textarea
                                    autocomplete="email"
                                    outlined
                                    v-model="filterInterview.interviewComment"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              rounded
                              outlined
                              @click="closeMyDialog(listTutor)"
                              class="btn-interview"
                          >
                            Đóng
                          </v-btn>
                          <v-btn
                              text
                              rounded
                              outlined
                              :disabled="invalid"
                              class="btn-interview"
                              @click.prevent="actionInterViewSave(listTutor)"
                          >
                            Lưu lại
                          </v-btn>
                        </v-card-actions>
                      </validation-observer>
                    </v-card>
                  </v-dialog>
                </div>
               
              </div>
            </template>
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 1"
            >
              <div style="text-align:left">
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M7.05002 5.99998L11.5 1.54998C11.8 1.24998 11.8 0.799976 11.5 0.499976C11.2 0.199976 10.75 0.199976 10.45 0.499976L6.00002 4.94998L1.55002 0.449976C1.25002 0.149976 0.800024 0.149976 0.500024 0.449976C0.200024 0.749976 0.200024 1.19998 0.500024 1.49998L4.95002 5.94998L0.500024 10.4C0.200024 10.7 0.200024 11.15 0.500024 11.45C0.650024 11.6 0.850024 11.65 1.05002 11.65C1.25002 11.65 1.45002 11.6 1.60002 11.45L6.05002 6.99998L10.5 11.45C10.65 11.6 10.85 11.65 11.05 11.65C11.25 11.65 11.45 11.6 11.6 11.45C11.9 11.15 11.9 10.7 11.6 10.4L7.05002 5.99998Z"
                      fill="#EB5757"
                  />
                </svg>
                <strong> Hủy </strong>
              </div>
            </template>
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 3"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between pl-1 pr-1"
                >
                  <div class="">
                    <v-icon
                        color="#6F7782"
                        style="font-size: 16px; margin-right: 6px; color: #6f7782"
                    >
                      mdi-check-circle
                    </v-icon>
                    <span class="font-weight-bold mr-2">Đã Pv</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showPopup"
                      persistent
                      max-width="800px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          color="#2F80ED"
                          dark
                          class="interview-btn"
                          height="24"
                          v-bind="attrs"
                          v-on="on"
                          @click="
                          interviewPopup(listTutor.contactTutorPractice[0])
                        "
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>

                      <v-card-title>
                          <span class="text-h5 mr-2 header-popup-interview"
                          >Thông tin phỏng vấn</span
                          >
                      </v-card-title>
                      <v-card-text>
                        <v-divider class="mb-5"></v-divider>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                              >Người phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn người phỏng vấn"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    required
                                    :error-messages="errors"
                                    item-text="fullName"
                                    item-value="id"
                                    dense
                                    placeholder="--Chọn chuyên môn--"
                                    outlined
                                    v-model="filterInterview.interviewUserId"
                                ></v-combobox>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                              >Trạng thái phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn trạng thái phỏng vấn"
                              >
                                <v-select
                                    :items="allStatus.interviewStatus"
                                    class="mr-3"
                                    :error-messages="errors"
                                    item-value="value"
                                    item-text="text"
                                    placeholder="Chờ phỏng vấn"
                                    outlined
                                    dense
                                    v-model="filterInterview.interviewStatus"
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" md="12">
                              <label
                                  for=""
                                  style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                              >Nhận xét
                              </label>
                              <v-textarea
                                  autocomplete="email"
                                  outlined
                                  v-model="filterInterview.interviewComment"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            rounded
                            outlined
                            class="btn-interview"
                            @click="closeMyDialog(listTutor)"
                        >
                          Đóng
                        </v-btn>
                        <v-btn
                            text
                            rounded
                            disabled
                            outlined

                            class="btn-interview"
                            @click="actionInterViewSave(listTutor)"
                        >
                          Lưu lại
                        </v-btn>
                      </v-card-actions>

                    </v-card>
                  </v-dialog>
                </div>
              
              </div>
            </template>
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 2"
            >
              <div class="text-center">
                <v-dialog
                    v-model="listTutor.showPopup"
                    persistent
                    max-width="800px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        @click="interviewPopup(listTutor.contactTutorPractice[0])"
                        color="#2F80ED"
                        width="100"
                        dark
                        v-bind="attrs"
                        v-on="on"
                    >
                      Chọn người Pv
                    </v-btn>
                  </template>
                  <v-card>
                    <validation-observer ref="validator" v-slot="{ invalid }">
                      <v-card-title>
                        <span class="text-h5 header-popup-interview"
                        >Thông tin phỏng vấn</span
                        >
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                  color: #000000;
                                  font-size: 16px;
                                  font-weight: normal;
                                "
                              >Người phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn người phỏng vấn"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    required
                                    :error-messages="errors"
                                    item-text="fullName"
                                    item-value="id"
                                    dense
                                    placeholder="--Chọn chuyên môn--"
                                    outlined
                                    v-model="filterInterview.interviewUserId"
                                ></v-combobox>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                  color: #000000;
                                  font-size: 16px;
                                  font-weight: normal;
                                "
                              >Trạng thái phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn trạng thái phỏng vấn"
                              >
                                <v-select
                                    :items="allStatus.interviewStatus"
                                    class="mr-3"
                                    :error-messages="errors"
                                    item-value="value"
                                    item-text="text"
                                    placeholder="Chờ phỏng vấn"
                                    outlined
                                    dense
                                    v-model="filterInterview.interviewStatus"
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" md="12">
                              <label
                                  for=""
                                  style="
                                  color: #000000;
                                  font-size: 16px;
                                  font-weight: normal;
                                "
                              >Nhận xét
                              </label>
                              <v-textarea
                                  autocomplete="email"
                                  outlined
                                  v-model="filterInterview.interviewComment"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            rounded
                            outlined
                            class="btn-interview"
                            @click="closeMyDialog(listTutor)"
                        >
                          Đóng
                        </v-btn>
                        <v-btn
                            text
                            rounded
                            outlined
                            :disabled="invalid"
                            class="btn-interview"
                            @click="actionInterViewSave(listTutor)"
                        >
                          Lưu lại
                        </v-btn>
                      </v-card-actions>
                    </validation-observer>
                  </v-card>
                </v-dialog>
              </div>
            </template>
          </th>
          <th v-else class="crossed"></th>
          <th style="white-space: nowrap">
            <div
                v-if="listTutor.contactTutorPractice[0].subjectId"
                class="d-flex justify-space-between"
                style="position: relative"
            >
              <div class="d-flex" style="flex-direction: column">
                <a :href="!listTutor.contactTutorPractice[0].testResult ? `${listTutor.contactTutorPractice[0].testLink}` : ''" class="mr-4" 
                :style="[!listTutor.contactTutorPractice[0].testResult ? {'color':'blue',} : {'color':'#333333','text-decoration':'unset'} ]"
                style="margin-bottom: 2px">
                  {{
                    getSubjectTitle(listTutor.contactTutorPractice[0].subjectId)
                  }}
                </a>
              </div>
            </div>
            <div v-else>
              <p style="margin-bottom: 2px; color: #e0e0e0">Chưa chọn</p>
              <v-icon class="mdi-icon-edit">mdi-square-edit-outline</v-icon>
            </div>
          </th>
          <th v-if="listTutor.contactTutorPractice[0].testResult" style="white-space:nowrap;position:relative">
            <div class="d-flex">
              <div></div>
              <strong>{{
                  listTutor.contactTutorPractice[0].testResult
                }}</strong>
              <a
                  :href="listTutor.contactTutorPractice[0].statusLink"
                  target="_blank"
                  style="text-decoration: unset;position:absolute;right: 0"
              >
                <v-icon class="mr-2" style="color: #0a4eaf;font-size:16px"
                >mdi-information
                </v-icon>
              </a
              >
            </div>
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>
          <th v-if="listTutor.contactTutorPractice[0].testResult" style="position:relative">
            <div
                v-if="listTutor.contactTutorPractice[0].commentStatus == 1"
                style="white-space: nowrap"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="d-flex align-center">
                    <svg style="margin-right: 6px; color: #6f7782" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM11.4 6.45C11.6 6.25 11.6 5.95 11.4 5.75C11.2 5.55 10.9 5.55 10.7 5.75L6.4 10.05L4.85 8.5C4.65 8.3 4.3 8.3 4.15 8.5C4 8.7 4 9 4.15 9.2L6.05 11.1C6.25 11.3 6.55 11.3 6.75 11.1L11.4 6.45Z" fill="#6F7782"/>
                    </svg>
                    <span class="font-weight-bold">Đã nhận xét</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showDialog"
                      width="1170"
                      persistent
                      :retain-focus="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          dark
                          style="position:absolute;right:0"
                          v-bind="attrs"
                          height="24"
                          v-on="on"
                          @click="
                          getDetailComment(listTutor.contactTutorPractice[0].id)
                        "
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                          class="
                          text-h5 text-left
                          font-weight-700
                          button
                          text-uppercase
                          pt-6
                          pb-6
                        "
                          style="color: #3cbac7; background: white"
                      >
                        TẠO PHIẾU NHẬN XÉT MÔN TOÁN
                        <v-row>
                          <v-col cols="12" md="7" class="">
                            <v-card
                                v-if="detailComment"
                                color=""
                                class="mt-5"
                                elevation="1"
                                outline
                                width="697"
                            >
                              <v-list-item three-line>
                                <v-list-item-avatar
                                    class="rounded-circle"
                                    tile
                                    size="80"
                                    color="grey"
                                >
                                  <v-img src="logo.png"></v-img
                                  >
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <div
                                      class="mb-2"
                                      style="
                                      color: #006e46;
                                      font-size: 16px;
                                      text-transform: capitalize;
                                    "
                                  >
                                    {{ detailComment.student_name }}
                                    
                                  </div>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66"
                                  >
                                    Ngày sinh: {{ detailComment.birthday }}
                                  </v-list-item-title>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66"
                                  >
                                    Số điện thoại: {{ listTutor.mobile }}
                                  </v-list-item-title>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66"
                                  >
                                    Ngày kiểm tra: {{detailComment.do_practice_date}}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                            <h4
                                class="mt-5"
                                style="color: #333333; text-transform: initial"
                            >
                              Nhận xét từ giáo viên
                            </h4>
                            <v-divider width="171"></v-divider>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <v-combobox
                                  :items="listInterview"
                                  label="Chọn người nhận xét"
                                  :error-messages="errors"
                                  dense
                                  outlined
                                  item-value="id"
                                  item-text="fullName"
                                  v-model="comments.commentBy"
                                  class="mt-4 text-capitalize"
                                  style="width: 200px"
                              ></v-combobox>
                            </validation-provider>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <div class="editor-style">
                                <vue-editor
                                    v-model="comments.commentContent"
                                ></vue-editor>
                              </div>
                              <span
                                  class="required-text"
                                  v-if="errors[0] && errors[0].length > 0"
                              >
                                {{ errors[0] }}
                              </span>
                            </validation-provider>
                            <h4
                                class="mt-5"
                                style="color: #333333; text-transform: initial"
                            >
                              Lộ trình học tập
                            </h4>
                            <v-divider width="171" class="mb-4"></v-divider>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <div class="editor-style">
                                <vue-editor
                                    v-model="comments.commentLearningPath"
                                ></vue-editor>
                              </div>
                              <span
                                  class="required-text"
                                  v-if="errors[0] && errors[0].length > 0"
                              >
                                {{ errors[0] }}
                              </span>
                            </validation-provider>
                          </v-col>
                          <v-col class="12" md="5" v-if="detailComment">
                            <v-row class="justify-center">
                              <div class="d-flex justify-center align-center">
                                <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                      width="60"
                                      height="60"
                                      rx="16"
                                      fill="#FDD5D7"
                                  />
                                  <path
                                      d="M39.6836 19.15V20.3833L33.7836 16.9667C31.5502 15.6833 28.4336 15.6833 26.2169 16.9667L20.3169 20.4V19.15C20.3169 15.4 22.3669 13.3333 26.1169 13.3333H33.8836C37.6336 13.3333 39.6836 15.4 39.6836 19.15Z"
                                      fill="#FD3C4A"
                                  />
                                  <path
                                      d="M39.7335 23.2833L39.5002 23.1667L37.2335 21.8667L32.5335 19.15C31.1002 18.3167 28.9002 18.3167 27.4668 19.15L22.7668 21.85L20.5002 23.1833L20.2002 23.3333C17.2835 25.3 17.0835 25.6667 17.0835 28.8167V36.35C17.0835 39.5 17.2835 39.8667 20.2668 41.8833L27.4668 46.0333C28.1835 46.4667 29.0835 46.65 30.0002 46.65C30.9002 46.65 31.8168 46.45 32.5335 46.0333L39.8002 41.8333C42.7335 39.8667 42.9168 39.5167 42.9168 36.35V28.8167C42.9168 25.6667 42.7168 25.3 39.7335 23.2833ZM34.6502 32.5L33.6335 33.75C33.4668 33.9333 33.3502 34.2833 33.3668 34.5333L33.4668 36.1333C33.5335 37.1167 32.8335 37.6167 31.9168 37.2667L30.4335 36.6667C30.2002 36.5833 29.8168 36.5833 29.5835 36.6667L28.1002 37.25C27.1835 37.6167 26.4835 37.1 26.5502 36.1167L26.6502 34.5167C26.6668 34.2667 26.5502 33.9167 26.3835 33.7333L25.3502 32.5C24.7168 31.75 25.0002 30.9167 25.9502 30.6667L27.5002 30.2667C27.7502 30.2 28.0335 29.9667 28.1668 29.7667L29.0335 28.4333C29.5668 27.6 30.4168 27.6 30.9668 28.4333L31.8335 29.7667C31.9668 29.9833 32.2668 30.2 32.5002 30.2667L34.0502 30.6667C35.0002 30.9167 35.2835 31.75 34.6502 32.5Z"
                                      fill="#FD3C4A"
                                  />
                                </svg>

                                <h1
                                    class="text-lowercase ml-4"
                                    style="color: #fd3c4a"
                                >
                                  {{ testScore }}/10 điểm
                                </h1>
                              </div>
                              <div id="chartis-graph" class="chartis-tutor-color">
                                <chartist
                                    ratio="ct-major-second"
                                    type="Bar"
                                    :data="chartData"
                                    :options="chartOptions"
                                    ref="my_chart"
                                >
                                </chartist>
                              </div>
                            </v-row>
                            <div
                                class="d-flex align-center justify-center mt-3"
                            >
                              <div class="d-flex align-center mr-8">
                                <v-sheet
                                    color="#00BA61"
                                    height="15"
                                    width="15"
                                    class="mr-2"
                                ></v-sheet>
                                <span class="shape-color">Số câu đúng</span>
                              </div>
                              <div class="d-flex align-center">
                                <v-sheet
                                    color="#FF3F3F"
                                    height="15"
                                    width="15"
                                    class="mr-2"
                                ></v-sheet>
                                <span class="shape-color">Số câu sai</span>
                              </div>
                            </div>
                            <div class="d-flex justify-center mt-3">
                              <v-btn
                                  color="#2F80ED"
                                  rounded
                                  outlined
                                  width="84"
                                  height="28"
                                  style="font-size: 10px"
                              >
                                <a
                                    v-if="detailComment"
                                    :href="detailComment.result_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style="text-decoration: unset; color: #2f80ed"
                                >Link chi tiết KQ</a
                                >
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#00A854"
                            outlined
                            height="34"
                            width="127"
                            style="border-radius: 42px"
                            @click="
                            listTutor.showDialog = false;
                            removeChartElement();
                          "
                        >
                          Bỏ qua
                        </v-btn>
                        <v-btn
                            color="#00A854"
                            disabled
                            @click="
                            createComment(listTutor.contactTutorPractice[0].id)
                          "
                            height="34"
                            width="127"
                            style="border-radius: 42px"
                        >
                          Lưu lại
                        </v-btn>
                        <v-snackbar v-model="snackbarComment">
                          Comment đã được lưu lại

                          <template v-slot:action="{ attrs }">
                            <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbarComment = false"
                            >
                              Close
                            </v-btn>
                          </template>
                        </v-snackbar>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].commentStatus == 0"
                style="white-space: nowrap"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="">
                    <svg
                        style="margin-right: 6px"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M8 0C8.32 0 8.53333 0.213333 8.53333 0.533333V2.66667C8.53333 2.98667 8.32 3.2 8 3.2C7.68 3.2 7.46667 2.98667 7.46667 2.66667V0.533333C7.46667 0.213333 7.68 0 8 0ZM8 12.8C8.32 12.8 8.53333 13.0133 8.53333 13.3333V15.4667C8.53333 15.7867 8.32 16 8 16C7.68 16 7.46667 15.7867 7.46667 15.4667V13.3333C7.46667 13.0133 7.68 12.8 8 12.8ZM12.8 8C12.8 7.68 13.0133 7.46667 13.3333 7.46667H15.4667C15.7867 7.46667 16 7.68 16 8C16 8.32 15.7867 8.53333 15.4667 8.53333H13.3333C13.0133 8.53333 12.8 8.32 12.8 8ZM0 8C0 7.68 0.213333 7.46667 0.533333 7.46667H2.66667C2.98667 7.46667 3.2 7.68 3.2 8C3.2 8.32 2.98667 8.53333 2.66667 8.53333H0.533333C0.213333 8.53333 0 8.32 0 8ZM13.6533 2.34667C13.8667 2.56 13.8667 2.88 13.6533 3.09333L12.16 4.58667C11.9467 4.8 11.6267 4.8 11.4133 4.58667C11.2 4.37333 11.2 4.05333 11.4133 3.84L12.9067 2.34667C13.12 2.13333 13.44 2.13333 13.6533 2.34667ZM4.58667 11.4133C4.8 11.6267 4.8 11.9467 4.58667 12.16L3.09333 13.6533C2.88 13.8667 2.56 13.8667 2.34667 13.6533C2.13333 13.44 2.13333 13.12 2.34667 12.9067L3.84 11.4133C4.05333 11.2 4.37333 11.2 4.58667 11.4133ZM11.4133 11.4133C11.6267 11.2 11.9467 11.2 12.16 11.4133L13.6533 12.9067C13.8667 13.12 13.8667 13.44 13.6533 13.6533C13.44 13.8667 13.12 13.8667 12.9067 13.6533L11.4133 12.16C11.2 11.9467 11.2 11.6267 11.4133 11.4133ZM2.34667 2.34667C2.56 2.13333 2.88 2.13333 3.09333 2.34667L4.58667 3.84C4.8 4.05333 4.8 4.37333 4.58667 4.58667C4.37333 4.8 4.05333 4.8 3.84 4.58667L2.34667 3.09333C2.13333 2.88 2.13333 2.56 2.34667 2.34667Z"
                          fill="#F2994A"
                      />
                    </svg>

                    <span class="font-weight-bold">Chờ nhận xét</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showDialog"
                      width="1170"
                      persistent
                      :retain-focus="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          dark
                          v-bind="attrs"
                          v-on="on"
                          style="position:absolute;right:0"
                          @click="
                          getDetailComment(listTutor.contactTutorPractice[0].id)
                        "
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <validation-observer ref="validator" v-slot="{ invalid }">
                        <v-card-title
                            class="
                            text-h5 text-left
                            font-weight-700
                            button
                            text-uppercase
                            pt-6
                            pb-6
                          "
                            style="
                            color: #3cbac7;
                            background: white;
                            font-weight: bold;
                          "
                        >
                          TẠO PHIẾU NHẬN XÉT MÔN TOÁN
                          <v-row>
                            <v-col cols="12" md="7" class="">
                              <v-card
                                  v-if="detailComment"
                                  color=""
                                  class="mt-5"
                                  elevation="1"
                                  outline
                                  width="697"
                              >
                                <v-list-item three-line>
                                  <v-list-item-avatar
                                      class="rounded-circle"
                                      tile
                                      size="80"
                                      color="grey"
                                  >
                                    <v-img src="logo.png"></v-img
                                    >
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <div
                                        class="mb-2"
                                        style="
                                        color: #006e46;
                                        font-size: 16px;
                                        text-transform: capitalize;
                                      "
                                    >
                                      {{ detailComment.student_name }}
                                     
                                    </div>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Ngày sinh: {{ detailComment.birthday }}
                                      <!-- {{ detailComment.birthday }} -->
                                    </v-list-item-title>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Số điện thoại: {{ listTutor.mobile }}
                                    </v-list-item-title>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Ngày kiểm tra: {{ detailComment.do_practice_date }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-card>
                              <h4
                                  class="mt-5"
                                  style="color: #333333; text-transform: initial"
                              >
                                Nhận xét từ giáo viên
                              </h4>
                              <v-divider width="171"></v-divider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Người nhận xét"
                                  rules="required"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    :error-messages="errors"
                                    label="Chọn người nhận xét"
                                    dense
                                    outlined
                                    item-text="fullName"
                                    item-value="id"
                                    v-model="comments.commentBy"
                                    class="mt-4 text-capitalize"
                                    style="width: 200px"
                                ></v-combobox>
                              </validation-provider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Nội dung"
                                  rules="required"
                              >
                                <div class="editor-style">
                                  <vue-editor
                                      v-model="comments.commentContent"
                                  ></vue-editor>
                                </div>
                                <span
                                    class="required-text"
                                    v-if="errors[0] && errors[0].length > 0"
                                >
                                  {{ errors[0] }}
                                </span>
                              </validation-provider>
                              <h4
                                  class="mt-5"
                                  style="color: #333333; text-transform: initial"
                              >
                                Lộ trình học tập
                              </h4>
                              <v-divider width="171" class="mb-4"></v-divider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Nội dung"
                                  rules="required"
                              >
                                <vue-editor
                                    v-model="comments.commentLearningPath"
                                ></vue-editor>
                                <span
                                    class="required-text"
                                    v-if="errors[0] && errors[0].length > 0"
                                >
                                  {{ errors[0] }}
                                </span>
                              </validation-provider>
                            </v-col>
                            <v-col class="12" md="5" v-if="detailComment">
                              <v-row class="justify-center">
                                <div class="d-flex justify-center align-center">
                                  <svg
                                      width="60"
                                      height="60"
                                      viewBox="0 0 60 60"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                        width="60"
                                        height="60"
                                        rx="16"
                                        fill="#FDD5D7"
                                    />
                                    <path
                                        d="M39.6836 19.15V20.3833L33.7836 16.9667C31.5502 15.6833 28.4336 15.6833 26.2169 16.9667L20.3169 20.4V19.15C20.3169 15.4 22.3669 13.3333 26.1169 13.3333H33.8836C37.6336 13.3333 39.6836 15.4 39.6836 19.15Z"
                                        fill="#FD3C4A"
                                    />
                                    <path
                                        d="M39.7335 23.2833L39.5002 23.1667L37.2335 21.8667L32.5335 19.15C31.1002 18.3167 28.9002 18.3167 27.4668 19.15L22.7668 21.85L20.5002 23.1833L20.2002 23.3333C17.2835 25.3 17.0835 25.6667 17.0835 28.8167V36.35C17.0835 39.5 17.2835 39.8667 20.2668 41.8833L27.4668 46.0333C28.1835 46.4667 29.0835 46.65 30.0002 46.65C30.9002 46.65 31.8168 46.45 32.5335 46.0333L39.8002 41.8333C42.7335 39.8667 42.9168 39.5167 42.9168 36.35V28.8167C42.9168 25.6667 42.7168 25.3 39.7335 23.2833ZM34.6502 32.5L33.6335 33.75C33.4668 33.9333 33.3502 34.2833 33.3668 34.5333L33.4668 36.1333C33.5335 37.1167 32.8335 37.6167 31.9168 37.2667L30.4335 36.6667C30.2002 36.5833 29.8168 36.5833 29.5835 36.6667L28.1002 37.25C27.1835 37.6167 26.4835 37.1 26.5502 36.1167L26.6502 34.5167C26.6668 34.2667 26.5502 33.9167 26.3835 33.7333L25.3502 32.5C24.7168 31.75 25.0002 30.9167 25.9502 30.6667L27.5002 30.2667C27.7502 30.2 28.0335 29.9667 28.1668 29.7667L29.0335 28.4333C29.5668 27.6 30.4168 27.6 30.9668 28.4333L31.8335 29.7667C31.9668 29.9833 32.2668 30.2 32.5002 30.2667L34.0502 30.6667C35.0002 30.9167 35.2835 31.75 34.6502 32.5Z"
                                        fill="#FD3C4A"
                                    />
                                  </svg>

                                  <h1
                                      class="text-lowercase ml-4"
                                      style="color: #fd3c4a"
                                  >
                                    {{ testScore }}/10 điểm
                                  </h1>
                                </div>
                                <div class="chartis-tutor-color">
                                  <chartist
                                      ratio="ct-major-second"
                                      type="Bar"
                                      :data="chartData"
                                      :options="chartOptions"
                                      ref="my_chart"
                                  >
                                  </chartist>
                                </div>
                              </v-row>
                              <div
                                  class="d-flex align-center justify-center mt-3"
                              >
                                <div class="d-flex align-center mr-8">
                                  <v-sheet
                                      color="#00BA61"
                                      height="15"
                                      width="15"
                                      class="mr-2"
                                  ></v-sheet>
                                  <span class="shape-color">Số câu đúng</span>
                                </div>
                                <div class="d-flex align-center">
                                  <v-sheet
                                      color="#FF3F3F"
                                      height="15"
                                      width="15"
                                      class="mr-2"
                                  ></v-sheet>
                                  <span class="shape-color">Số câu sai</span>
                                </div>
                              </div>
                              <div class="d-flex justify-center mt-3">
                                <v-btn
                                    color="#2F80ED"
                                    rounded
                                    outlined
                                    width="84"
                                    height="28"
                                    style="font-size: 10px"
                                >
                                  <a
                                      v-if="detailComment"
                                      :href="detailComment.result_link"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style="
                                      text-decoration: unset;
                                      color: #2f80ed;
                                    "
                                  >Link chi tiết KQ</a
                                  >
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="#00A854"
                              outlined
                              height="34"
                              width="127"
                              style="border-radius: 42px"
                              @click="
                              listTutor.showDialog = false;
                              removeChartElement();
                            "
                          >
                            Bỏ qua
                          </v-btn>
                          <v-btn
                              color="#00A854"
                              :disabled="invalid"
                              @click="
                              createComment(
                                listTutor.contactTutorPractice[0].id
                              )
                            "
                              height="34"
                              width="127"
                              style="border-radius: 42px"
                          >
                            Lưu lại
                          </v-btn>
                        </v-card-actions>
                      </validation-observer>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].order != null"
              style="font-weight: 700"
          >
            {{ listTutor.contactTutorPractice[0].order.code }}
          </th>
          <th
              v-else
              style="color: rgb(224, 224, 224);font-size:font-size: 14px"
          >
            chưa có
          </th>
          <th v-if="listTutor.contactTutorPractice[0].order">
            {{
              getStatusText(listTutor.contactTutorPractice[0].order.statusId)
            }}
          </th>
          <th
              v-else
              style="color: rgb(224, 224, 224);font-size:font-size: 14px"
          >
            Chưa có
          </th>
          <!-- <th :rowspan="listTutor.contactTutorPractice.length">
            <div>
              <v-icon class="mdi-icon-phone" style="color: #67ad5b"
                >mdi-phone</v-icon
              >

              <v-icon class="mdi-icon-pencil" style="color: #d73864"
                >mdi-pencil</v-icon
              >

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="
                      clickExecuteCall(listTutor, listTutor.mobile)
                    "
                    class="mr-1"
                    icon
                    small
                    color="success"
                    v-on="on"
                  >
                    <v-icon>mdi-phone</v-icon>
                  </v-btn>
                </template>
                <span>Gọi cho khách hàng</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-1"
                    @click="clickContact(listTutor)"
                    icon
                    small
                    color="rgb(215, 56, 100)"
                    v-on="on"
                  >
                    <v-icon size="16">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Cập nhật thông tin khách hàng</span>
              </v-tooltip>
            </div>
          </th>-->
        </tr>
        <tr v-for="contactPractice in listTutor.contactTutorPractice.slice(1)">
          <th style="background: #fdf7e4;white-space: nowrap;" >
            
              {{ getSubjectName(contactPractice.subjectId) }}
            
          </th>
          <th
              class="th-yellow d-flex"
              :style="
              `height: 57px;
              border-bottom: 1px solid #e0e0e0;
             
              border-left: none;
              border-right: none;
              border-top: none;
              `
            "
          >
            <div class="" v-if="contactPractice.status === 0" style="white-space: nowrap;">
              <svg
                  style="margin-right: 8px"
                  width="14"
                  height="16"
                  viewBox="0 0 14 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M4 6.75C4.4 6.75 4.75 7.1 4.75 7.5C4.75 7.9 4.4 8.25 4 8.25C3.6 8.25 3.25 7.9 3.25 7.5C3.25 7.1 3.6 6.75 4 6.75ZM10.5 7H6.5C6.2 7 6 7.2 6 7.5C6 7.8 6.2 8 6.5 8H10.5C10.8 8 11 7.8 11 7.5C11 7.2 10.8 7 10.5 7ZM10.5 10H6.5C6.2 10 6 10.2 6 10.5C6 10.8 6.2 11 6.5 11H10.5C10.8 11 11 10.8 11 10.5C11 10.2 10.8 10 10.5 10ZM4 9.75C4.4 9.75 4.75 10.1 4.75 10.5C4.75 10.9 4.4 11.25 4 11.25C3.6 11.25 3.25 10.9 3.25 10.5C3.25 10.1 3.6 9.75 4 9.75ZM11 1H9.9C9.7 0.4 9.15 0 8.5 0H5.5C4.85 0 4.3 0.4 4.1 1H3C1.35 1 0 2.35 0 4V13C0 14.65 1.35 16 3 16H11C12.65 16 14 14.65 14 13V4C14 2.35 12.65 1 11 1ZM5.5 1H8.5C8.8 1 9 1.2 9 1.5V2.5C9 2.8 8.8 3 8.5 3H5.5C5.2 3 5 2.8 5 2.5V1.5C5 1.2 5.2 1 5.5 1ZM13 13C13 14.1 12.1 15 11 15H3C1.9 15 1 14.1 1 13V4C1 2.9 1.9 2 3 2H4V2.5C4 3.35 4.65 4 5.5 4H8.5C9.35 4 10 3.35 10 2.5V2H11C12.1 2 13 2.9 13 4V13Z"
                    fill="#EB5757"
                />
              </svg>
              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ Test</span
              >
            </div>
            <div
                v-if="contactPractice.status == 1"
                class="th-yellow"
                style="white-space: nowrap;transform: translate(2px, 7px);height: 10px;"
            >
              <svg
                  class="mr-2"
                  width="15"
                  height="15"
                  viewBox="0 0 15 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M7 8C9.2 8 11 6.2 11 4C11 1.8 9.2 0 7 0C4.8 0 3 1.8 3 4C3 6.2 4.8 8 7 8ZM7 1C8.65 1 10 2.35 10 4C10 5.65 8.65 7 7 7C5.35 7 4 5.65 4 4C4 2.35 5.35 1 7 1ZM13.5 11.9C13.2 11.9 13 12.1 13 12.4V14.5C13 14.8 13.2 15 13.5 15C13.8 15 14 14.8 14 14.5V12.4C14 12.1 13.8 11.9 13.5 11.9ZM11.1 9.5C11.1 9.2 10.9 9 10.6 9H3.4C1.5 9 0 10.5 0 12.4V14.5C0 14.8 0.2 15 0.5 15C0.8 15 1 14.8 1 14.5V12.4C1 11.1 2.1 10 3.4 10H10.6C10.9 10 11.1 9.8 11.1 9.5ZM13.9 9.1C13.7 8.9 13.4 8.9 13.2 9.1L9.15 13.15L7.8 11.8C7.6 11.6 7.3 11.6 7.1 11.8C6.9 12 6.9 12.3 7.1 12.5L8.8 14.2C8.9 14.3 9 14.35 9.15 14.35C9.3 14.35 9.4 14.3 9.5 14.2L13.9 9.8C14.1 9.6 14.1 9.3 13.9 9.1Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ Pv</span
              >
            </div>
            <div
                v-if="contactPractice.status == 2"
                class="th-yellow mt-4"
                style="white-space: nowrap"
            >
              <svg
                  class="mr-2"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M11 1V0.5C11 0.2 10.8 0 10.5 0C10.2 0 10 0.2 10 0.5V1H4V0.5C4 0.2 3.8 0 3.5 0C3.2 0 3 0.2 3 0.5V1C1.35 1 0 2.35 0 4V12C0 13.65 1.35 15 3 15H11C12.65 15 14 13.65 14 12V4C14 2.35 12.65 1 11 1ZM13 12C13 13.1 12.1 14 11 14H3C1.9 14 1 13.1 1 12V4C1 2.9 1.9 2 3 2V2.5C3 2.8 3.2 3 3.5 3C3.8 3 4 2.8 4 2.5V2H10V2.5C10 2.8 10.2 3 10.5 3C10.8 3 11 2.8 11 2.5V2C12.1 2 13 2.9 13 4V12ZM5 5H9.4V6.05L6.75 11H5.35L7.95 6.15H5V5Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ lịch hẹn</span
              >
            </div>
            <div
                v-if="contactPractice.status == 3"
                class="th-yellow"
                style="white-space: nowrap"
            >
              <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M4.09998 15C3.89998 15 3.74998 14.95 3.59998 14.85C3.34998 14.65 3.19998 14.35 3.24998 14L3.89998 10.1L1.04998 7.35C0.799984 7.1 0.749984 6.75 0.849984 6.45C0.949984 6.15 1.19998 5.9 1.54998 5.85L5.44998 5.3L7.19998 1.75C7.34998 1.45 7.64998 1.25 7.99998 1.25C8.34998 1.25 8.64998 1.45 8.79998 1.75L10.55 5.3L14.45 5.85C14.8 5.9 15.05 6.15 15.15 6.45C15.25 6.75 15.15 7.1 14.95 7.35L12.1 10.1L12.75 14C12.8 14.35 12.65 14.65 12.4 14.85C12.15 15.05 11.8 15.05 11.5 14.9L7.99998 13.05L4.49998 14.9C4.39998 15 4.24998 15 4.09998 15ZM7.99998 11.95L11.75 13.9L11.05 9.75L14.1 6.8L9.89998 6.2L7.99998 2.4L6.14998 6.2L1.94998 6.8L4.99998 9.75L4.29998 13.9L7.99998 11.95Z"
                    fill="#EB5757"
                />
              </svg>

              <span class="font-weight-bold" style="white-space: nowrap"
              >Chờ Nx</span
              >
            </div>
            <div
                v-if="contactPractice.status == 5"
                class="th-yellow d-flex align-center"
                style="white-space: nowrap"
            >
              <a :href="`${contactPractice.appointmentLink} ? 'listTutor.contactPractice.appointmentLink' ? ''`"
              style="text-decoration: unset"
              >
                  <v-icon
                    color="#6F7782"
                    style="font-size: 16px; margin-right: 6px; color: #25e8c8"
                >mdi-checkbox-marked-circle
                </v-icon>
                <span class="font-weight-bold d-inline-block" v-if="contactPractice.appointmentLink" style="white-space: nowrap;color:blue;text-decoration: underline">
              Done
            </span>
              <span v-else class="font-weight-bold" style="white-space: nowrap">
              Done
            </span>
              </a>
            </div>
          </th>
          <th v-if="contactPractice.appointmentTime">
            <div class="d-flex flex-column justity-start">
              <div
                  style="position: relative"
                  v-if="contactPractice.appointmentTime"
              >
                <strong class="ml-1">{{
                    appointmenTimeText(contactPractice.appointmentTime).time
                  }}</strong>
                <span>
                  {{
                    appointmenTimeText(contactPractice.appointmentTime).date
                  }}</span
                >
                <v-menu
                    ref="menu"
                    
                    :close-on-content-click="false"
                    :return-value.sync="myDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        dark
                        height="24"
                        class="update-time-btn"
                        v-if="contactPractice.status != 5"
                        @click="showTime(contactPractice.appointmentTime)"
                        v-on="on"
                        v-bind="attrs"
                    >
                      <svg
                          style="position: absolute; right: 4px"
                          v-if="contactPractice.status != 5"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                              d="M8.5 12.0002H1.5C0.673 12.0002 0 11.3272 0 10.5002V3.50024C0 2.67324 0.673 2.00024 1.5 2.00024H5.5C5.7765 2.00024 6 2.22424 6 2.50024C6 2.77624 5.7765 3.00024 5.5 3.00024H1.5C1.224 3.00024 1 3.22474 1 3.50024V10.5002C1 10.7757 1.224 11.0002 1.5 11.0002H8.5C8.776 11.0002 9 10.7757 9 10.5002V6.50024C9 6.22424 9.2235 6.00024 9.5 6.00024C9.7765 6.00024 10 6.22424 10 6.50024V10.5002C10 11.3272 9.327 12.0002 8.5 12.0002Z"
                              fill="#607D8B"
                          />
                          <path
                              d="M8.64403 1.58929L4.68803 5.54529C4.65303 5.58029 4.62953 5.62479 4.61953 5.67279L4.26603 7.44079C4.24953 7.52279 4.27503 7.60779 4.33453 7.66679C4.38203 7.71429 4.44603 7.73979 4.51153 7.73979L4.56053 7.73479L6.32803 7.38129C6.37703 7.37179 6.42103 7.34779 6.45603 7.31279L10.412 3.35679L8.64403 1.58929Z"
                              fill="#42A5F5"
                          />
                          <path
                              d="M11.6339 0.365747C11.1464 -0.121753 10.3534 -0.121753 9.86644 0.365747L9.17444 1.05775L10.9419 2.82525L11.6339 2.13325C11.8699 1.89775 11.9999 1.58375 11.9999 1.24975C11.9999 0.915747 11.8699 0.601747 11.6339 0.365747Z"
                              fill="#42A5F5"
                          />
                          <path
                              d="M9.49994 6C9.22344 6 8.99994 6.224 8.99994 6.5V10.5C8.99994 10.7755 8.77594 11 8.49994 11H1.49994C1.36194 11 1.23694 10.944 1.14644 10.8535L0.439941 11.56C0.711441 11.832 1.08644 12 1.49994 12H8.49994C9.32694 12 9.99994 11.327 9.99994 10.5V6.5C9.99994 6.2235 9.77644 6 9.49994 6Z"
                              fill="#546D79"
                          />
                          <path
                              d="M9.52797 2.4726L4.33447 7.66609C4.38197 7.71359 4.44597 7.73909 4.51147 7.73909L4.56047 7.73409L6.32797 7.38059C6.37697 7.37109 6.42097 7.34709 6.45597 7.31209L10.412 3.35609L9.52797 2.4726Z"
                              fill="#3990D5"
                          />
                          <path
                              d="M11.634 0.36615L10.0585 1.94165L10.9425 2.82565L11.6345 2.13365C11.87 1.89815 12 1.58415 12 1.25015C12 0.91615 11.87 0.60215 11.634 0.36615Z"
                              fill="#3990D5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </v-btn>
                  </template>
                   <div class="time-update-clendar">
                  <DatetimePicker
                      dateIcon
                      timeIcon
                      v-model="myDate"
                      no-title
                      label="Lịch hẹn"
                      time-format="HH:mm:ss"
                      date-format="MM/dd/yyyy"
                      @input="updateAppointmentTime(contactPractice)"
                  >
                    <template slot="dateIcon">
                      <v-icon
                      >mdi-calendar-range
                      </v-icon
                      >
                    </template>
                    <template slot="timeIcon">
                      <v-icon
                      >mdi-clock-outline
                      </v-icon
                      >
                    </template>
                  </DatetimePicker>
                   </div>
                </v-menu>
              </div>
              <div v-else></div>
              <div v-if="contactPractice.status != 5" style="display:none">
                <small
                    class="small-text ml-1"
                    v-if="
                    timeUnitsBetween(
                      new Date(),
                      new Date(contactPractice.appointmentTime)
                    ).includes('Đã quá hạn')
                  "
                    style="color: red"
                >{{
                    timeUnitsBetween(
                        new Date(),
                        new Date(contactPractice.appointmentTime)
                    )
                  }} </small
                >
                <small class="small-text ml-1" v-else style="color: rgb(130 130 130 / 52%);">{{
                    timeUnitsBetween(
                        new Date(),
                        new Date(contactPractice.appointmentTime)
                    )
                  }}</small>
              </div>
            </div>
          </th>
          <th v-else>
            <div class="d-flex justify-space-around align-center">
              <span style="color: #e0e0e0">Chưa chọn</span>
              <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  :return-value.sync="myDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      dark
                      height="24"
                      @click="showTime(contactPractice.appointmentTime)"
                      v-on="on"
                      v-bind="attrs"
                  >
                    <svg
                        style="position: absolute; right: 4px"
                        v-if="contactPractice.status != 5"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                            d="M8.5 12.0002H1.5C0.673 12.0002 0 11.3272 0 10.5002V3.50024C0 2.67324 0.673 2.00024 1.5 2.00024H5.5C5.7765 2.00024 6 2.22424 6 2.50024C6 2.77624 5.7765 3.00024 5.5 3.00024H1.5C1.224 3.00024 1 3.22474 1 3.50024V10.5002C1 10.7757 1.224 11.0002 1.5 11.0002H8.5C8.776 11.0002 9 10.7757 9 10.5002V6.50024C9 6.22424 9.2235 6.00024 9.5 6.00024C9.7765 6.00024 10 6.22424 10 6.50024V10.5002C10 11.3272 9.327 12.0002 8.5 12.0002Z"
                            fill="#607D8B"
                        />
                        <path
                            d="M8.64403 1.58929L4.68803 5.54529C4.65303 5.58029 4.62953 5.62479 4.61953 5.67279L4.26603 7.44079C4.24953 7.52279 4.27503 7.60779 4.33453 7.66679C4.38203 7.71429 4.44603 7.73979 4.51153 7.73979L4.56053 7.73479L6.32803 7.38129C6.37703 7.37179 6.42103 7.34779 6.45603 7.31279L10.412 3.35679L8.64403 1.58929Z"
                            fill="#42A5F5"
                        />
                        <path
                            d="M11.6339 0.365747C11.1464 -0.121753 10.3534 -0.121753 9.86644 0.365747L9.17444 1.05775L10.9419 2.82525L11.6339 2.13325C11.8699 1.89775 11.9999 1.58375 11.9999 1.24975C11.9999 0.915747 11.8699 0.601747 11.6339 0.365747Z"
                            fill="#42A5F5"
                        />
                        <path
                            d="M9.49994 6C9.22344 6 8.99994 6.224 8.99994 6.5V10.5C8.99994 10.7755 8.77594 11 8.49994 11H1.49994C1.36194 11 1.23694 10.944 1.14644 10.8535L0.439941 11.56C0.711441 11.832 1.08644 12 1.49994 12H8.49994C9.32694 12 9.99994 11.327 9.99994 10.5V6.5C9.99994 6.2235 9.77644 6 9.49994 6Z"
                            fill="#546D79"
                        />
                        <path
                            d="M9.52797 2.4726L4.33447 7.66609C4.38197 7.71359 4.44597 7.73909 4.51147 7.73909L4.56047 7.73409L6.32797 7.38059C6.37697 7.37109 6.42097 7.34709 6.45597 7.31209L10.412 3.35609L9.52797 2.4726Z"
                            fill="#3990D5"
                        />
                        <path
                            d="M11.634 0.36615L10.0585 1.94165L10.9425 2.82565L11.6345 2.13365C11.87 1.89815 12 1.58415 12 1.25015C12 0.91615 11.87 0.60215 11.634 0.36615Z"
                            fill="#3990D5"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="12" height="12" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </v-btn>
                </template>
                 <div class="time-update-clendar">
                <DatetimePicker
                    dateIcon
                    timeIcon
                    v-model="myDate"
                    no-title
                    label="Lịch hẹn"
                    time-format="HH:mm:ss"
                    date-format="MM/dd/yyyy"
                    @input="updateAppointmentTime(contactPractice)"
                >
                  <template slot="dateIcon">
                    <v-icon
                    >mdi-calendar-range
                    </v-icon
                    >
                  </template>
                  <template slot="timeIcon">
                    <v-icon
                    >mdi-clock-outline
                    </v-icon
                    >
                  </template>
                </DatetimePicker>
                 </div>
              </v-menu>
            </div>
          </th>
          <th style="white-space: nowrap"
              :style="[contactPractice.interviewStatus == 2 ? {'padding':'0 12px'} : '']"
              v-if="contactPractice.subjectId == 2">
            <div>
              <template v-if="contactPractice.interviewStatus == 0">
                <div
                    class="d-flex justify-space-between flex-column"
                >
                  <div
                      class="d-flex justify-space-between align-center pl-1 pr-1"
                  >
                    <div class="d-flex">
                      <svg
                          class="mr-2"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                            d="M8 0C8.32 0 8.53333 0.213333 8.53333 0.533333V2.66667C8.53333 2.98667 8.32 3.2 8 3.2C7.68 3.2 7.46667 2.98667 7.46667 2.66667V0.533333C7.46667 0.213333 7.68 0 8 0ZM8 12.8C8.32 12.8 8.53333 13.0133 8.53333 13.3333V15.4667C8.53333 15.7867 8.32 16 8 16C7.68 16 7.46667 15.7867 7.46667 15.4667V13.3333C7.46667 13.0133 7.68 12.8 8 12.8ZM12.8 8C12.8 7.68 13.0133 7.46667 13.3333 7.46667H15.4667C15.7867 7.46667 16 7.68 16 8C16 8.32 15.7867 8.53333 15.4667 8.53333H13.3333C13.0133 8.53333 12.8 8.32 12.8 8ZM0 8C0 7.68 0.213333 7.46667 0.533333 7.46667H2.66667C2.98667 7.46667 3.2 7.68 3.2 8C3.2 8.32 2.98667 8.53333 2.66667 8.53333H0.533333C0.213333 8.53333 0 8.32 0 8ZM13.6533 2.34667C13.8667 2.56 13.8667 2.88 13.6533 3.09333L12.16 4.58667C11.9467 4.8 11.6267 4.8 11.4133 4.58667C11.2 4.37333 11.2 4.05333 11.4133 3.84L12.9067 2.34667C13.12 2.13333 13.44 2.13333 13.6533 2.34667ZM4.58667 11.4133C4.8 11.6267 4.8 11.9467 4.58667 12.16L3.09333 13.6533C2.88 13.8667 2.56 13.8667 2.34667 13.6533C2.13333 13.44 2.13333 13.12 2.34667 12.9067L3.84 11.4133C4.05333 11.2 4.37333 11.2 4.58667 11.4133ZM11.4133 11.4133C11.6267 11.2 11.9467 11.2 12.16 11.4133L13.6533 12.9067C13.8667 13.12 13.8667 13.44 13.6533 13.6533C13.44 13.8667 13.12 13.8667 12.9067 13.6533L11.4133 12.16C11.2 11.9467 11.2 11.6267 11.4133 11.4133ZM2.34667 2.34667C2.56 2.13333 2.88 2.13333 3.09333 2.34667L4.58667 3.84C4.8 4.05333 4.8 4.37333 4.58667 4.58667C4.37333 4.8 4.05333 4.8 3.84 4.58667L2.34667 3.09333C2.13333 2.88 2.13333 2.56 2.34667 2.34667Z"
                            fill="#F2994A"
                        />
                      </svg>

                      <span class="font-weight-bold mr-2">Chờ Pv</span>
                    </div>
                    <v-dialog
                        :retain-focus="false"
                        max-width="800px"
                        ref="myDialog"
                        v-model="listTutor.showPopup"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            dark
                            height="24"
                            width="8"
                            v-bind="attrs"
                            v-on="on"
                            @click="interviewPopup(contactPractice)"
                        >
                          <v-icon style="color: #0a4eaf;font-size:16px"
                          >mdi-information
                          </v-icon
                          >
                        </v-btn>
                      </template>
                      <v-card>
                        <validation-observer
                            ref="validator"
                            v-slot="{ invalid }"
                        >
                          <v-card-title>
                            <span class="text-h5 mr-2 header-popup-interview"
                            >Thông tin phỏng vấn</span
                            >
                          </v-card-title>

                          <v-card-text>
                            <v-divider class="mb-5"></v-divider>
                            <v-container>
                              <v-row>
                                <v-col cols="12" sm="6">
                                  <label
                                      for=""
                                      style="
                                      color: #000000;
                                      font-size: 16px;
                                      font-weight: normal;
                                    "
                                  >Người phỏng vấn
                                    <span style="color: red">(*)</span>
                                  </label>
                                  <validation-provider
                                      v-slot="{ errors }"
                                      rules="required"
                                      name="Chọn người phỏng vấn"
                                  >
                                    <v-combobox
                                        :items="listInterview"
                                        required
                                        :error-messages="errors"
                                        item-text="fullName"
                                        item-value="id"
                                        dense
                                        placeholder="--Chọn chuyên môn--"
                                        outlined
                                        v-model="filterInterview.interviewUserId"
                                    ></v-combobox>
                                  </validation-provider>
                                </v-col>
                                <v-col cols="12" sm="6">
                                  <label
                                      for=""
                                      style="
                                      color: #000000;
                                      font-size: 16px;
                                      font-weight: normal;
                                    "
                                  >Trạng thái phỏng vấn
                                    <span style="color: red">(*)</span>
                                  </label>
                                  <validation-provider
                                      v-slot="{ errors }"
                                      rules="required"
                                      name="Chọn trạng thái phỏng vấn"
                                  >
                                    <v-select
                                        :items="allStatus.interviewStatus"
                                        class="mr-3"
                                        :error-messages="errors"
                                        item-value="value"
                                        item-text="text"
                                        placeholder="Chờ phỏng vấn"
                                        outlined
                                        dense
                                        v-model="filterInterview.interviewStatus"
                                    ></v-select>
                                  </validation-provider>
                                </v-col>
                                <v-col cols="12" md="12">
                                  <label
                                      for=""
                                      style="
                                      color: #000000;
                                      font-size: 16px;
                                      font-weight: normal;
                                    "
                                  >Nhận xét
                                  </label>
                                  <v-textarea
                                      autocomplete="email"
                                      outlined
                                      v-model="filterInterview.interviewComment"
                                  ></v-textarea>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-card-text>
                          <v-card-actions class="d-flex">
                            <v-spacer></v-spacer>
                            <v-btn
                                text
                                rounded
                                outlined
                                class="btn-interview"
                                @click="closeMyDialog(listTutor)"
                            >
                              Đóng
                            </v-btn>
                            <v-btn
                                text
                                rounded
                                outlined
                                :disabled="invalid"
                                class="btn-interview"
                                @click="actionInterViewSave(listTutor)"
                            >
                              Lưu lại
                            </v-btn>
                          </v-card-actions>
                        </validation-observer>
                      </v-card>
                    </v-dialog>
                  </div>
      
                </div>
              </template>
              <template v-if="contactPractice.interviewStatus == 1">
                <div style="text-align:left">
                  <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                        d="M7.05002 5.99998L11.5 1.54998C11.8 1.24998 11.8 0.799976 11.5 0.499976C11.2 0.199976 10.75 0.199976 10.45 0.499976L6.00002 4.94998L1.55002 0.449976C1.25002 0.149976 0.800024 0.149976 0.500024 0.449976C0.200024 0.749976 0.200024 1.19998 0.500024 1.49998L4.95002 5.94998L0.500024 10.4C0.200024 10.7 0.200024 11.15 0.500024 11.45C0.650024 11.6 0.850024 11.65 1.05002 11.65C1.25002 11.65 1.45002 11.6 1.60002 11.45L6.05002 6.99998L10.5 11.45C10.65 11.6 10.85 11.65 11.05 11.65C11.25 11.65 11.45 11.6 11.6 11.45C11.9 11.15 11.9 10.7 11.6 10.4L7.05002 5.99998Z"
                        fill="#EB5757"
                    />
                  </svg>
                  <strong> Hủy </strong>

                </div>
              </template>
              <template v-if="contactPractice.interviewStatus == 3">
                <div
                    class="d-flex justify-space-between flex-column"
                >
                  <div
                      class="d-flex justify-space-between align-center pl-1 pr-1"
                  >
                    <div class="">
                      <v-icon
                          color="#6F7782"
                          style="
                          font-size: 16px;
                          margin-right: 6px;
                          color: #6f7782;
                        "
                      >
                        mdi-check-circle
                      </v-icon>
                      <span class="font-weight-bold mr-2">Đã Pv</span>
                    </div>
                    <v-dialog
                        v-model="listTutor.showPopup"
                        persistent
                        max-width="800px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            icon
                            color="#2F80ED"
                            dark
                            height="24"
                            width="8px"
                            v-bind="attrs"
                            v-on="on"
                            @click="interviewPopup(contactPractice)"
                        >
                          <v-icon style="color: #0a4eaf;font-size:16px"
                          >mdi-information
                          </v-icon
                          >
                        </v-btn>
                      </template>
                      <v-card>

                        <v-card-title>
                            <span class="text-h5 mr-2 header-popup-interview"
                            >Thông tin phỏng vấn</span
                            >
                        </v-card-title>
                        <v-card-text>
                          <v-divider class="mb-5"></v-divider>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                      color: #000000;
                                      font-size: 16px;
                                      font-weight: normal;
                                    "
                                >Người phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn người phỏng vấn"
                                >
                                  <v-combobox
                                      :items="listInterview"
                                      required
                                      :error-messages="errors"
                                      item-text="fullName"
                                      item-value="id"
                                      dense
                                      placeholder="--Chọn chuyên môn--"
                                      outlined
                                      v-model="filterInterview.interviewUserId"
                                  ></v-combobox>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                      color: #000000;
                                      font-size: 16px;
                                      font-weight: normal;
                                    "
                                >Trạng thái phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn trạng thái phỏng vấn"
                                >
                                  <v-select
                                      :items="allStatus.interviewStatus"
                                      class="mr-3"
                                      :error-messages="errors"
                                      item-value="value"
                                      item-text="text"
                                      placeholder="Chờ phỏng vấn"
                                      outlined
                                      dense
                                      v-model="filterInterview.interviewStatus"
                                  ></v-select>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" md="12">
                                <label
                                    for=""
                                    style="
                                      color: #000000;
                                      font-size: 16px;
                                      font-weight: normal;
                                    "
                                >Nhận xét
                                </label>
                                <v-textarea
                                    autocomplete="email"
                                    outlined
                                    v-model="filterInterview.interviewComment"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              rounded
                              outlined
                              class="btn-interview"
                              @click="closeMyDialog(listTutor)"
                          >
                            Đóng
                          </v-btn>
                          <v-btn
                              text
                              rounded
                              outlined
                              disabled
                              class="btn-interview"
                              @click="actionInterViewSave(listTutor)"
                          >
                            Lưu lại
                          </v-btn>
                        </v-card-actions>

                      </v-card>
                    </v-dialog>
                  </div>
                 
                </div>
              </template>
              <template v-if="contactPractice.interviewStatus == 2">
                <div class="text-center">
                  <v-dialog
                      v-model="listTutor.showPopup"
                      persistent
                      max-width="800px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          @click="interviewPopup(contactPractice)"
                          color="#2F80ED"
                          width="100"
                          dark
                          v-bind="attrs"
                          v-on="on"
                      >
                        Chọn người Pv
                      </v-btn>
                    </template>
                    <v-card>
                      <validation-observer ref="validator" v-slot="{ invalid }">
                        <v-card-title>
                          <span class="text-h5 header-popup-interview"
                          >Thông tin phỏng vấn</span
                          >
                        </v-card-title>
                        <v-card-text>
                          <v-divider class="mb-5"></v-divider>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Người phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn người phỏng vấn"
                                >
                                  <v-combobox
                                      :items="listInterview"
                                      required
                                      :error-messages="errors"
                                      item-text="fullName"
                                      item-value="id"
                                      dense
                                      placeholder="--Chọn chuyên môn--"
                                      outlined
                                      v-model="filterInterview.interviewUserId"
                                  ></v-combobox>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Trạng thái phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn trạng thái phỏng vấn"
                                >
                                  <v-select
                                      :items="allStatus.interviewStatus"
                                      class="mr-3"
                                      :error-messages="errors"
                                      item-value="value"
                                      item-text="text"
                                      placeholder="Chờ phỏng vấn"
                                      outlined
                                      dense
                                      v-model="filterInterview.interviewStatus"
                                  ></v-select>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" md="12">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Nhận xét
                                </label>
                                <v-textarea
                                    autocomplete="email"
                                    outlined
                                    v-model="filterInterview.interviewComment"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              rounded
                              outlined
                              class="btn-interview"
                              @click="closeMyDialog(listTutor)"
                          >
                            Đóng
                          </v-btn>
                          <v-btn
                              text
                              rounded
                              outlined
                              :disabled="invalid"
                              class="btn-interview"
                              @click="actionInterViewSave(listTutor)"
                          >
                            Lưu lại
                          </v-btn>
                        </v-card-actions>
                      </validation-observer>
                    </v-card>
                  </v-dialog>
                </div>
              </template>
            </div>
          </th>
          <th
              v-if="contactPractice.subjectId == 1"
              class="crossed"
              id="crossed"
          ></th>
          <th style="white-space:nowrap">
            <div style="" class="pt-0 d-flex justify-space-between">
              <div
                  v-if="contactPractice.subjectId"
                  class="d-flex justity-start"
                  style="position: relative"
              >
                <div
                    class="d-flex justify-start flex-column"
                    style="margin-right: 16px"
                >
                  <a :href="!contactPractice.testResult ? `${contactPractice.testLink}` : '#'"
                      style="margin-bottom: 2px"
                      :style="[!contactPractice.testResult ? {'color':'blue'} : {'color':'#333333','text-decoration':'unset'} ]">
                    {{ getSubjectTitle(contactPractice.subjectId) }}
                  </a>
                </div>
                
              </div>
              <div v-else>
                <p style="margin-bottom: 2px; color: #e0e0e0">Chưa chọn</p>
                <v-icon class="mdi-icon-edit">mdi-square-edit-outline</v-icon>
              </div>
              
            </div>
          </th>
          <th v-if="contactPractice.testResult" style="position:relative">
            <div class="d-flex">
              <div></div>
              <strong>{{ contactPractice.testResult }}</strong>
              <a
                  :href="contactPractice.statusLink"
                  target="_blank"
                  style="text-decoration: unset;position:absolute;right: 0"
              >
                <v-icon class="mr-2" style="color: #0a4eaf;font-size:16px"
                >mdi-information
                </v-icon>
              </a
              >
            </div>
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>
          <th v-if="contactPractice.testResult" style="position:relative">
            <div
                v-if="contactPractice.commentStatus == 1"
                style="white-space: nowrap"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="d-flex align-center">
                    <svg style="margin-right: 6px; color: #6f7782" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM11.4 6.45C11.6 6.25 11.6 5.95 11.4 5.75C11.2 5.55 10.9 5.55 10.7 5.75L6.4 10.05L4.85 8.5C4.65 8.3 4.3 8.3 4.15 8.5C4 8.7 4 9 4.15 9.2L6.05 11.1C6.25 11.3 6.55 11.3 6.75 11.1L11.4 6.45Z" fill="#6F7782"/>
                    </svg>
                    <span class="font-weight-bold">Đã nhận xét</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showDialog"
                      width="1170"
                      :retain-focus="false"
                      persistent
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          @click="getDetailComment(contactPractice.id)"
                          icon
                          dark
                          height="24"
                          v-bind="attrs"
                          v-on="on"
                          style="position:absolute;right:0"

                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title
                          class="
                          text-h5 text-left
                          font-weight-700
                          button
                          text-uppercase
                          pt-6
                          pb-6
                        "
                          style="
                          color: #3cbac7;
                          background: white;
                          font-weight: bold;
                        "
                      >
                        TẠO PHIẾU NHẬN XÉT MÔN TOÁN
                        <v-row>
                          <v-col cols="12" md="7" class="">
                            <v-card
                                v-if="detailComment"
                                color=""
                                class="mt-5"
                                elevation="1"
                                outline
                                width="697"
                            >
                              <v-list-item three-line>
                                <v-list-item-avatar
                                    class="rounded-circle"
                                    tile
                                    size="80"
                                    color="grey"
                                >
                                  <v-img src="logo.png"></v-img
                                  >
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <div
                                      class="mb-2"
                                      style="
                                      color: #006e46;
                                      font-size: 16px;
                                      text-transform: capitalize;
                                    "
                                  >
                                    {{ detailComment.student_name }}
                                  
                                  </div>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66"
                                  >
                                    Ngày sinh: {{ detailComment.birthday }}
                                  </v-list-item-title>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66"
                                  >
                                    Số điện thoại: {{ listTutor.mobile }}
                                  </v-list-item-title>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66"
                                  >
                                    Ngày kiểm tra:{{ detailComment.do_practice_date }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                            <h4
                                class="mt-5"
                                style="color: #333333; text-transform: initial"
                            >
                              Nhận xét từ giáo viên
                            </h4>
                            <v-divider width="171"></v-divider>
                            <v-combobox
                                :items="listInterview"
                                label="Chọn người nhận xét"
                                dense
                                outlined
                                item-value="id"
                                item-text="fullName"
                                v-model="comments.commentBy"
                                class="mt-4 text-capitalize"
                                style="width: 200px"
                            ></v-combobox>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <vue-editor
                                  v-model="comments.commentContent"
                              ></vue-editor>
                              <span
                                  class="required-text"
                                  v-if="errors[0] && errors[0].length > 0"
                              >
                                {{ errors[0] }}
                              </span>
                            </validation-provider>
                            <h4
                                class="mt-5"
                                style="color: #333333; text-transform: initial"
                            >
                              Lộ trình học tập
                            </h4>
                            <v-divider width="171" class="mb-4"></v-divider>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <vue-editor
                                  v-model="comments.commentLearningPath"
                              ></vue-editor>
                              <span
                                  class="required-text"
                                  v-if="errors[0] && errors[0].length > 0"
                              >
                                {{ errors[0] }}
                              </span>
                            </validation-provider>
                          </v-col>
                          <v-col class="12" md="5" v-if="detailComment">
                            <v-row class="justify-center">
                              <div class="d-flex justify-center align-center">
                                <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                      width="60"
                                      height="60"
                                      rx="16"
                                      fill="#FDD5D7"
                                  />
                                  <path
                                      d="M39.6836 19.15V20.3833L33.7836 16.9667C31.5502 15.6833 28.4336 15.6833 26.2169 16.9667L20.3169 20.4V19.15C20.3169 15.4 22.3669 13.3333 26.1169 13.3333H33.8836C37.6336 13.3333 39.6836 15.4 39.6836 19.15Z"
                                      fill="#FD3C4A"
                                  />
                                  <path
                                      d="M39.7335 23.2833L39.5002 23.1667L37.2335 21.8667L32.5335 19.15C31.1002 18.3167 28.9002 18.3167 27.4668 19.15L22.7668 21.85L20.5002 23.1833L20.2002 23.3333C17.2835 25.3 17.0835 25.6667 17.0835 28.8167V36.35C17.0835 39.5 17.2835 39.8667 20.2668 41.8833L27.4668 46.0333C28.1835 46.4667 29.0835 46.65 30.0002 46.65C30.9002 46.65 31.8168 46.45 32.5335 46.0333L39.8002 41.8333C42.7335 39.8667 42.9168 39.5167 42.9168 36.35V28.8167C42.9168 25.6667 42.7168 25.3 39.7335 23.2833ZM34.6502 32.5L33.6335 33.75C33.4668 33.9333 33.3502 34.2833 33.3668 34.5333L33.4668 36.1333C33.5335 37.1167 32.8335 37.6167 31.9168 37.2667L30.4335 36.6667C30.2002 36.5833 29.8168 36.5833 29.5835 36.6667L28.1002 37.25C27.1835 37.6167 26.4835 37.1 26.5502 36.1167L26.6502 34.5167C26.6668 34.2667 26.5502 33.9167 26.3835 33.7333L25.3502 32.5C24.7168 31.75 25.0002 30.9167 25.9502 30.6667L27.5002 30.2667C27.7502 30.2 28.0335 29.9667 28.1668 29.7667L29.0335 28.4333C29.5668 27.6 30.4168 27.6 30.9668 28.4333L31.8335 29.7667C31.9668 29.9833 32.2668 30.2 32.5002 30.2667L34.0502 30.6667C35.0002 30.9167 35.2835 31.75 34.6502 32.5Z"
                                      fill="#FD3C4A"
                                  />
                                </svg>

                                <h1
                                    class="text-lowercase ml-4"
                                    style="color: #fd3c4a"
                                >
                                  {{ testScore }}/10 điểm
                                </h1>
                              </div>
                              <div class="chartis-tutor-color">
                                <chartist
                                    ratio="ct-major-second"
                                    type="Bar"
                                    :data="chartData"
                                    :options="chartOptions"
                                    ref="my_chart"
                                >
                                </chartist>
                              </div>
                            </v-row>
                            <div
                                class="d-flex align-center justify-center mt-3"
                            >
                              <div class="d-flex align-center mr-8">
                                <v-sheet
                                    color="#00BA61"
                                    height="15"
                                    width="15"
                                    class="mr-2"
                                ></v-sheet>
                                <span class="shape-color">Số câu đúng</span>
                              </div>
                              <div class="d-flex align-center">
                                <v-sheet
                                    color="#FF3F3F"
                                    height="15"
                                    width="15"
                                    class="mr-2"
                                ></v-sheet>
                                <span class="shape-color">Số câu sai</span>
                              </div>
                            </div>
                            <div class="d-flex justify-center mt-3">
                              <v-btn
                                  color="#2F80ED"
                                  rounded
                                  outlined
                                  width="84"
                                  height="28"
                                  style="font-size: 10px"
                              >
                                <a
                                    v-if="detailComment"
                                    :href="detailComment.result_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style="text-decoration: unset; color: #2f80ed"
                                >Link chi tiết KQ</a
                                >
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#00A854"
                            outlined
                            height="34"
                            width="127"
                            @click="
                            listTutor.showDialog = false;
                            removeChartElement();
                          "
                            style="border-radius: 42px"
                        >
                          Bỏ qua
                        </v-btn>
                        <v-btn
                            color="#00A854"
                            disabled
                            @click="createComment(contactPractice.id)"
                            height="34"
                            width="127"
                            style="border-radius: 42px"
                        >
                          Lưu lại
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
            <div
                v-if="contactPractice.commentStatus == 0"
                style="white-space: nowrap"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="">
                    <svg
                        style="margin-right: 6px"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M8 0C8.32 0 8.53333 0.213333 8.53333 0.533333V2.66667C8.53333 2.98667 8.32 3.2 8 3.2C7.68 3.2 7.46667 2.98667 7.46667 2.66667V0.533333C7.46667 0.213333 7.68 0 8 0ZM8 12.8C8.32 12.8 8.53333 13.0133 8.53333 13.3333V15.4667C8.53333 15.7867 8.32 16 8 16C7.68 16 7.46667 15.7867 7.46667 15.4667V13.3333C7.46667 13.0133 7.68 12.8 8 12.8ZM12.8 8C12.8 7.68 13.0133 7.46667 13.3333 7.46667H15.4667C15.7867 7.46667 16 7.68 16 8C16 8.32 15.7867 8.53333 15.4667 8.53333H13.3333C13.0133 8.53333 12.8 8.32 12.8 8ZM0 8C0 7.68 0.213333 7.46667 0.533333 7.46667H2.66667C2.98667 7.46667 3.2 7.68 3.2 8C3.2 8.32 2.98667 8.53333 2.66667 8.53333H0.533333C0.213333 8.53333 0 8.32 0 8ZM13.6533 2.34667C13.8667 2.56 13.8667 2.88 13.6533 3.09333L12.16 4.58667C11.9467 4.8 11.6267 4.8 11.4133 4.58667C11.2 4.37333 11.2 4.05333 11.4133 3.84L12.9067 2.34667C13.12 2.13333 13.44 2.13333 13.6533 2.34667ZM4.58667 11.4133C4.8 11.6267 4.8 11.9467 4.58667 12.16L3.09333 13.6533C2.88 13.8667 2.56 13.8667 2.34667 13.6533C2.13333 13.44 2.13333 13.12 2.34667 12.9067L3.84 11.4133C4.05333 11.2 4.37333 11.2 4.58667 11.4133ZM11.4133 11.4133C11.6267 11.2 11.9467 11.2 12.16 11.4133L13.6533 12.9067C13.8667 13.12 13.8667 13.44 13.6533 13.6533C13.44 13.8667 13.12 13.8667 12.9067 13.6533L11.4133 12.16C11.2 11.9467 11.2 11.6267 11.4133 11.4133ZM2.34667 2.34667C2.56 2.13333 2.88 2.13333 3.09333 2.34667L4.58667 3.84C4.8 4.05333 4.8 4.37333 4.58667 4.58667C4.37333 4.8 4.05333 4.8 3.84 4.58667L2.34667 3.09333C2.13333 2.88 2.13333 2.56 2.34667 2.34667Z"
                          fill="#F2994A"
                      />
                    </svg>

                    <span class="font-weight-bold">Chờ nhận xét </span>
                  </div>
                  <v-dialog v-model="dialogInfo" width="1170">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          dark
                          v-bind="attrs"
                          v-on="on"
                          style="position:absolute;right:0"
                          @click="getDetailComment(contactPractice.id)"
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <validation-observer ref="validator" v-slot="{ invalid }">
                        <v-card-title
                            class="
                            text-h5 text-left
                            font-weight-700
                            button
                            text-uppercase
                            pt-6
                            pb-6
                          "
                            style="
                            color: #3cbac7;
                            background: white;
                            font-weight: bold;
                          "
                        >
                          TẠO PHIẾU NHẬN XÉT MÔN TOÁN
                          <v-row>
                            <v-col cols="12" md="7" class="">
                              <v-card
                                  v-if="detailComment"
                                  color=""
                                  class="mt-5"
                                  elevation="1"
                                  outline
                                  width="697"
                              >
                                <v-list-item three-line>
                                  <v-list-item-avatar
                                      class="rounded-circle"
                                      tile
                                      size="80"
                                      color="grey"
                                  >
                                    <v-img src="logo.png"></v-img
                                    >
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <div
                                        class="mb-2"
                                        style="
                                        color: #006e46;
                                        font-size: 16px;
                                        text-transform: capitalize;
                                      "
                                    >
                                      {{ detailComment.student_name }}
                                     
                                    </div>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Ngày sinh :{{ detailComment.birthday }}
                                    </v-list-item-title>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Số điện thoại: {{ listTutor.mobile }}
                                    </v-list-item-title>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Ngày kiểm tra:
                                      {{ detailComment.do_practice_date }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-card>
                              <h4
                                  class="mt-5"
                                  style="color: #333333; text-transform: initial"
                              >
                                Nhận xét từ giáo viên
                              </h4>
                              <v-divider width="171"></v-divider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Người nhận xét"
                                  rules="required"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    label="Chọn người nhận xét"
                                    :error-messages="errors"
                                    dense
                                    outlined
                                    item-text="fullName"
                                    item-value="id"
                                    v-model="comments.commentBy"
                                    class="mt-4 text-capitalize"
                                    style="width: 200px"
                                ></v-combobox>
                              </validation-provider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Nội dung"
                                  rules="required"
                              >
                                <vue-editor
                                    v-model="comments.commentContent"
                                ></vue-editor>
                                <span
                                    class="required-text"
                                    v-if="errors[0] && errors[0].length > 0"
                                >
                                  {{ errors[0] }}
                                </span>
                              </validation-provider>
                              <h4
                                  class="mt-5"
                                  style="color: #333333; text-transform: initial"
                              >
                                Lộ trình học tập
                              </h4>
                              <v-divider width="171" class="mb-4"></v-divider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Nội dung"
                                  rules="required"
                              >
                                <vue-editor
                                    v-model="comments.commentLearningPath"
                                ></vue-editor>
                                <span
                                    class="required-text"
                                    v-if="errors[0] && errors[0].length > 0"
                                >
                                  {{ errors[0] }}
                                </span>
                              </validation-provider>
                            </v-col>
                            <v-col class="12" md="5" v-if="detailComment">
                              <v-row class="justify-center">
                                <div class="d-flex justify-center align-center">
                                  <svg
                                      width="60"
                                      height="60"
                                      viewBox="0 0 60 60"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                        width="60"
                                        height="60"
                                        rx="16"
                                        fill="#FDD5D7"
                                    />
                                    <path
                                        d="M39.6836 19.15V20.3833L33.7836 16.9667C31.5502 15.6833 28.4336 15.6833 26.2169 16.9667L20.3169 20.4V19.15C20.3169 15.4 22.3669 13.3333 26.1169 13.3333H33.8836C37.6336 13.3333 39.6836 15.4 39.6836 19.15Z"
                                        fill="#FD3C4A"
                                    />
                                    <path
                                        d="M39.7335 23.2833L39.5002 23.1667L37.2335 21.8667L32.5335 19.15C31.1002 18.3167 28.9002 18.3167 27.4668 19.15L22.7668 21.85L20.5002 23.1833L20.2002 23.3333C17.2835 25.3 17.0835 25.6667 17.0835 28.8167V36.35C17.0835 39.5 17.2835 39.8667 20.2668 41.8833L27.4668 46.0333C28.1835 46.4667 29.0835 46.65 30.0002 46.65C30.9002 46.65 31.8168 46.45 32.5335 46.0333L39.8002 41.8333C42.7335 39.8667 42.9168 39.5167 42.9168 36.35V28.8167C42.9168 25.6667 42.7168 25.3 39.7335 23.2833ZM34.6502 32.5L33.6335 33.75C33.4668 33.9333 33.3502 34.2833 33.3668 34.5333L33.4668 36.1333C33.5335 37.1167 32.8335 37.6167 31.9168 37.2667L30.4335 36.6667C30.2002 36.5833 29.8168 36.5833 29.5835 36.6667L28.1002 37.25C27.1835 37.6167 26.4835 37.1 26.5502 36.1167L26.6502 34.5167C26.6668 34.2667 26.5502 33.9167 26.3835 33.7333L25.3502 32.5C24.7168 31.75 25.0002 30.9167 25.9502 30.6667L27.5002 30.2667C27.7502 30.2 28.0335 29.9667 28.1668 29.7667L29.0335 28.4333C29.5668 27.6 30.4168 27.6 30.9668 28.4333L31.8335 29.7667C31.9668 29.9833 32.2668 30.2 32.5002 30.2667L34.0502 30.6667C35.0002 30.9167 35.2835 31.75 34.6502 32.5Z"
                                        fill="#FD3C4A"
                                    />
                                  </svg>

                                  <h1
                                      class="text-lowercase ml-4"
                                      style="color: #fd3c4a"
                                  >
                                    {{ testScore }}/10 điểm
                                  </h1>
                                </div>
                                <div class="chartis-tutor-color">
                                  <chartist
                                      ratio="ct-major-second"
                                      type="Bar"
                                      :data="chartData"
                                      :options="chartOptions"
                                      ref="my_chart"
                                  >
                                  </chartist>
                                </div>
                              </v-row>
                              <div
                                  class="d-flex align-center justify-center mt-3"
                              >
                                <div class="d-flex align-center mr-8">
                                  <v-sheet
                                      color="#00BA61"
                                      height="15"
                                      width="15"
                                      class="mr-2"
                                  ></v-sheet>
                                  <span class="shape-color">Số câu đúng</span>
                                </div>
                                <div class="d-flex align-center">
                                  <v-sheet
                                      color="#FF3F3F"
                                      height="15"
                                      width="15"
                                      class="mr-2"
                                  ></v-sheet>
                                  <span class="shape-color">Số câu sai</span>
                                </div>
                              </div>
                              <div class="d-flex justify-center mt-3">
                                <v-btn
                                    color="#2F80ED"
                                    rounded
                                    outlined
                                    width="84"
                                    height="28"
                                    style="font-size: 10px"
                                >
                                  <a
                                      v-if="detailComment"
                                      :href="detailComment.result_link"
                                      target="_blank"
                                      style="
                                      text-decoration: unset;
                                      color: #2f80ed;
                                    "
                                      rel="text-decoration: unset;noopener noreferrer"
                                  >Link chi tiết KQ</a
                                  >
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="#00A854"
                              outlined
                              height="34"
                              width="127"
                              style="border-radius: 42px"
                              @click="
                              dialogInfo = false;
                              removeChartElement();
                            "
                          >
                            Bỏ qua
                          </v-btn>
                          <v-btn
                              color="#00A854"
                              :disabled="invalid"
                              @click="createComment(contactPractice.id)"
                              height="34"
                              width="127"
                              style="border-radius: 42px"
                          >
                            Lưu lại
                          </v-btn>
                        </v-card-actions>
                      </validation-observer>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
          </th>
          <th
              v-else
              style="color: rgb(224, 224, 224);font-size:font-size: 14px"
          >
            Chưa có
          </th>
          <th v-if="contactPractice.order != null" style="font-weight: 700">
            {{ contactPractice.order.code }}
          </th>
          <th
              v-else
              style="color: rgb(224, 224, 224);font-size:font-size: 14px"
          >
            chưa có
          </th>
          <th v-if="contactPractice.order">
            {{ getStatusText(contactPractice.order.statusId) }}
          </th>
          <th
              v-else
              style="color: rgb(224, 224, 224);font-size:font-size: 14px"
          >
            chưa có
          </th>
        </tr>
      </template>
      <template v-else>
        <tr>
          <th rowspan="" style="text-align:center">
            <input type="checkbox"/>
          </th>
          <th rowspan="" class="space-row">{{ listTutor.parentName }}</th>
          <th rowspan="" class="space-row">{{ listTutor.mobile }}</th>
          <th rowspan="" class="space-row">{{ listTutor.userName }}</th>
          <th class="th-yellow">
           
            {{getSubjectName(listTutor.contactTutorPractice[0].subjectId)}}
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].status == 0"
              class="th-yellow"
              style="font-weight: 700; white-space: nowrap"
          >
            <svg
                class="mr-2"
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M4 6.75C4.4 6.75 4.75 7.1 4.75 7.5C4.75 7.9 4.4 8.25 4 8.25C3.6 8.25 3.25 7.9 3.25 7.5C3.25 7.1 3.6 6.75 4 6.75ZM10.5 7H6.5C6.2 7 6 7.2 6 7.5C6 7.8 6.2 8 6.5 8H10.5C10.8 8 11 7.8 11 7.5C11 7.2 10.8 7 10.5 7ZM10.5 10H6.5C6.2 10 6 10.2 6 10.5C6 10.8 6.2 11 6.5 11H10.5C10.8 11 11 10.8 11 10.5C11 10.2 10.8 10 10.5 10ZM4 9.75C4.4 9.75 4.75 10.1 4.75 10.5C4.75 10.9 4.4 11.25 4 11.25C3.6 11.25 3.25 10.9 3.25 10.5C3.25 10.1 3.6 9.75 4 9.75ZM11 1H9.9C9.7 0.4 9.15 0 8.5 0H5.5C4.85 0 4.3 0.4 4.1 1H3C1.35 1 0 2.35 0 4V13C0 14.65 1.35 16 3 16H11C12.65 16 14 14.65 14 13V4C14 2.35 12.65 1 11 1ZM5.5 1H8.5C8.8 1 9 1.2 9 1.5V2.5C9 2.8 8.8 3 8.5 3H5.5C5.2 3 5 2.8 5 2.5V1.5C5 1.2 5.2 1 5.5 1ZM13 13C13 14.1 12.1 15 11 15H3C1.9 15 1 14.1 1 13V4C1 2.9 1.9 2 3 2H4V2.5C4 3.35 4.65 4 5.5 4H8.5C9.35 4 10 3.35 10 2.5V2H11C12.1 2 13 2.9 13 4V13Z"
                  fill="#EB5757"
              />
            </svg>

            <span class="font-weight-bold" style="white-space: nowrap">
              Chờ Test
            </span>
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].status == 1"
              class="th-yellow"
              style="font-weight: 700; white-space: nowrap"
          >
            <svg
                class="mr-2"
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M7 8C9.2 8 11 6.2 11 4C11 1.8 9.2 0 7 0C4.8 0 3 1.8 3 4C3 6.2 4.8 8 7 8ZM7 1C8.65 1 10 2.35 10 4C10 5.65 8.65 7 7 7C5.35 7 4 5.65 4 4C4 2.35 5.35 1 7 1ZM13.5 11.9C13.2 11.9 13 12.1 13 12.4V14.5C13 14.8 13.2 15 13.5 15C13.8 15 14 14.8 14 14.5V12.4C14 12.1 13.8 11.9 13.5 11.9ZM11.1 9.5C11.1 9.2 10.9 9 10.6 9H3.4C1.5 9 0 10.5 0 12.4V14.5C0 14.8 0.2 15 0.5 15C0.8 15 1 14.8 1 14.5V12.4C1 11.1 2.1 10 3.4 10H10.6C10.9 10 11.1 9.8 11.1 9.5ZM13.9 9.1C13.7 8.9 13.4 8.9 13.2 9.1L9.15 13.15L7.8 11.8C7.6 11.6 7.3 11.6 7.1 11.8C6.9 12 6.9 12.3 7.1 12.5L8.8 14.2C8.9 14.3 9 14.35 9.15 14.35C9.3 14.35 9.4 14.3 9.5 14.2L13.9 9.8C14.1 9.6 14.1 9.3 13.9 9.1Z"
                  fill="#EB5757"
              />
            </svg>

            <span class="font-weight-bold" style="white-space: nowrap">
              Chờ Pv
            </span>
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].status == 2"
              class="th-yellow"
              style="font-weight: 700; white-space: nowrap"
          >
            <svg
                class="mr-2"
                width="14"
                height="15"
                viewBox="0 0 14 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M11 1V0.5C11 0.2 10.8 0 10.5 0C10.2 0 10 0.2 10 0.5V1H4V0.5C4 0.2 3.8 0 3.5 0C3.2 0 3 0.2 3 0.5V1C1.35 1 0 2.35 0 4V12C0 13.65 1.35 15 3 15H11C12.65 15 14 13.65 14 12V4C14 2.35 12.65 1 11 1ZM13 12C13 13.1 12.1 14 11 14H3C1.9 14 1 13.1 1 12V4C1 2.9 1.9 2 3 2V2.5C3 2.8 3.2 3 3.5 3C3.8 3 4 2.8 4 2.5V2H10V2.5C10 2.8 10.2 3 10.5 3C10.8 3 11 2.8 11 2.5V2C12.1 2 13 2.9 13 4V12ZM5 5H9.4V6.05L6.75 11H5.35L7.95 6.15H5V5Z"
                  fill="#EB5757"
              />
            </svg>

            <span class="font-weight-bold" style="white-space: nowrap">
              Chờ lịch hẹn
            </span>
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].status == 3"
              class="th-yellow"
              style="font-weight: 700; white-space: nowrap"
          >
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
              <path
                  d="M4.09998 15C3.89998 15 3.74998 14.95 3.59998 14.85C3.34998 14.65 3.19998 14.35 3.24998 14L3.89998 10.1L1.04998 7.35C0.799984 7.1 0.749984 6.75 0.849984 6.45C0.949984 6.15 1.19998 5.9 1.54998 5.85L5.44998 5.3L7.19998 1.75C7.34998 1.45 7.64998 1.25 7.99998 1.25C8.34998 1.25 8.64998 1.45 8.79998 1.75L10.55 5.3L14.45 5.85C14.8 5.9 15.05 6.15 15.15 6.45C15.25 6.75 15.15 7.1 14.95 7.35L12.1 10.1L12.75 14C12.8 14.35 12.65 14.65 12.4 14.85C12.15 15.05 11.8 15.05 11.5 14.9L7.99998 13.05L4.49998 14.9C4.39998 15 4.24998 15 4.09998 15ZM7.99998 11.95L11.75 13.9L11.05 9.75L14.1 6.8L9.89998 6.2L7.99998 2.4L6.14998 6.2L1.94998 6.8L4.99998 9.75L4.29998 13.9L7.99998 11.95Z"
                  fill="#EB5757"
              />
            </svg>

            <span class="font-weight-bold" style="white-space: nowrap">
              Chờ Nx
            </span>
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].status == 5"
              class="th-yellow"
              style="font-weight: 700; white-space: nowrap"
          >
            
            <a :href="`${listTutor.contactTutorPractice[0].appointmentLink} ? 'listTutor.contactTutorPractice[0].appointmentLink' ? ''`"
              style="text-decoration: unset"
            >
              <v-icon
                  color="#6F7782"
                  style="font-size: 16px; margin-right: 6px; color: #25e8c8"
              >
                mdi-checkbox-marked-circle
              </v-icon>
              <span class="font-weight-bold d-inline-block" v-if="listTutor.contactTutorPractice[0].appointmentLink" style="white-space: nowrap;color:blue;text-decoration: underline">
              Done
            </span>
              <span v-else class="font-weight-bold" style="white-space: nowrap">
              Done
            </span>
            </a>
            <!-- <a v-if="listTutor.contactTutorPractice[0].appointmentLink && listTutor.contactTutorPractice[0].status == 5"
               :href="listTutor.contactTutorPractice[0].appointmentLink"
               style="font-size:12px;color:#2F80ED;font-weight: lighter">Link đánh giá</a> -->
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].status == null"
              class="th-yellow"
              style="font-weight: 700; white-space: nowrap"
          ></th>
          <th
              style="white-space: nowrap"
              v-if="listTutor.contactTutorPractice[0].appointmentTime"
          >
            <div class="d-flex flex-column justity-start">
              <div
                  style="position: relative"
                  v-if="listTutor.contactTutorPractice[0].appointmentTime"
              >
                <strong class="ml-1">{{
                    appointmenTimeText(
                        listTutor.contactTutorPractice[0].appointmentTime
                    ).time
                  }}</strong>
                <span>
                  {{
                    appointmenTimeText(
                        listTutor.contactTutorPractice[0].appointmentTime
                    ).date
                  }}</span
                >
                <v-menu
                    ref="menu"
                    v-if="listTutor.contactTutorPractice[0].status != 5"
                    v-model="listTutor.showDate"
                    :close-on-content-click="false"
                    :return-value.sync="myDate"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        dark
                        class="update-time-btn"
                        height="24"
                        @click="
                        showTime(
                          listTutor.contactTutorPractice[0].appointmentTime
                        )
                      "
                        v-on="on"
                        v-bind="attrs"
                    >
                      <svg
                          style="position: absolute; right: 4px"
                          v-if="listTutor.contactTutorPractice[0].status != 5"
                          width="12"
                          height="12"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0)">
                          <path
                              d="M8.5 12.0002H1.5C0.673 12.0002 0 11.3272 0 10.5002V3.50024C0 2.67324 0.673 2.00024 1.5 2.00024H5.5C5.7765 2.00024 6 2.22424 6 2.50024C6 2.77624 5.7765 3.00024 5.5 3.00024H1.5C1.224 3.00024 1 3.22474 1 3.50024V10.5002C1 10.7757 1.224 11.0002 1.5 11.0002H8.5C8.776 11.0002 9 10.7757 9 10.5002V6.50024C9 6.22424 9.2235 6.00024 9.5 6.00024C9.7765 6.00024 10 6.22424 10 6.50024V10.5002C10 11.3272 9.327 12.0002 8.5 12.0002Z"
                              fill="#607D8B"
                          />
                          <path
                              d="M8.64403 1.58929L4.68803 5.54529C4.65303 5.58029 4.62953 5.62479 4.61953 5.67279L4.26603 7.44079C4.24953 7.52279 4.27503 7.60779 4.33453 7.66679C4.38203 7.71429 4.44603 7.73979 4.51153 7.73979L4.56053 7.73479L6.32803 7.38129C6.37703 7.37179 6.42103 7.34779 6.45603 7.31279L10.412 3.35679L8.64403 1.58929Z"
                              fill="#42A5F5"
                          />
                          <path
                              d="M11.6339 0.365747C11.1464 -0.121753 10.3534 -0.121753 9.86644 0.365747L9.17444 1.05775L10.9419 2.82525L11.6339 2.13325C11.8699 1.89775 11.9999 1.58375 11.9999 1.24975C11.9999 0.915747 11.8699 0.601747 11.6339 0.365747Z"
                              fill="#42A5F5"
                          />
                          <path
                              d="M9.49994 6C9.22344 6 8.99994 6.224 8.99994 6.5V10.5C8.99994 10.7755 8.77594 11 8.49994 11H1.49994C1.36194 11 1.23694 10.944 1.14644 10.8535L0.439941 11.56C0.711441 11.832 1.08644 12 1.49994 12H8.49994C9.32694 12 9.99994 11.327 9.99994 10.5V6.5C9.99994 6.2235 9.77644 6 9.49994 6Z"
                              fill="#546D79"
                          />
                          <path
                              d="M9.52797 2.4726L4.33447 7.66609C4.38197 7.71359 4.44597 7.73909 4.51147 7.73909L4.56047 7.73409L6.32797 7.38059C6.37697 7.37109 6.42097 7.34709 6.45597 7.31209L10.412 3.35609L9.52797 2.4726Z"
                              fill="#3990D5"
                          />
                          <path
                              d="M11.634 0.36615L10.0585 1.94165L10.9425 2.82565L11.6345 2.13365C11.87 1.89815 12 1.58415 12 1.25015C12 0.91615 11.87 0.60215 11.634 0.36615Z"
                              fill="#3990D5"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0">
                            <rect width="12" height="12" fill="white"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </v-btn>
                  </template>
                   <div class="time-update-clendar">
                  <DatetimePicker
                      dateIcon
                      timeIcon
                      v-model="myDate"
                      no-title
                      label="Lịch hẹn"
                      time-format="HH:mm:ss"
                      date-format="MM/dd/yyyy"
                      @input="updateAppointmentTime(listTutor.contactTutorPractice[0])"
                  >
                    <template slot="dateIcon">
                      <v-icon
                      >mdi-calendar-range
                      </v-icon
                      >
                    </template>
                    <template slot="timeIcon">
                      <v-icon
                      >mdi-clock-outline
                      </v-icon
                      >
                    </template>
                  </DatetimePicker>
                   </div>
                </v-menu>
              </div>
              <div v-else></div>
              <div
                  v-if="
                  listTutor.contactTutorPractice[0].status != 5 &&
                  listTutor.contactTutorPractice[0].appointmentTime
                "
                style="display:none"
              >
                <small
                    class="small-text  ml-1"
                    v-if="
                    timeUnitsBetween(
                      new Date(),
                      new Date(
                        listTutor.contactTutorPractice[0].appointmentTime
                      )
                    ).includes('Đã quá hạn')
                  "
                    style="color: red"
                >{{
                    timeUnitsBetween(
                        new Date(),
                        new Date(
                            listTutor.contactTutorPractice[0].appointmentTime
                        )
                    )
                  }}</small
                >
                <small class="small-text ml-1" v-else style="color: rgb(130 130 130 / 52%);">{{
                    timeUnitsBetween(
                        new Date(),
                        new Date(listTutor.contactTutorPractice[0].appointmentTime)
                    )
                  }}</small>
                <!-- <small v-if=" !listTutor.contactTutorPractice[0].appointmentTime"></small> -->
              </div>
            </div>
          </th>
          <th v-else style="position:relative">
            <div class="d-flex align-center">
              <span style="color: #e0e0e0">Chưa chọn</span>
              <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  :return-value.sync="myDate"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      dark
                      style="position:absolute;right:12px"
                      height="24"
                      @click="
                      showTime(
                        listTutor.contactTutorPractice[0].appointmentTime
                      )
                    "
                      v-on="on"
                      v-bind="attrs"
                  >
                    <svg
                        style="position: absolute; right: 4px"
                        v-if="listTutor.contactTutorPractice[0].status != 5"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clip-path="url(#clip0)">
                        <path
                            d="M8.5 12.0002H1.5C0.673 12.0002 0 11.3272 0 10.5002V3.50024C0 2.67324 0.673 2.00024 1.5 2.00024H5.5C5.7765 2.00024 6 2.22424 6 2.50024C6 2.77624 5.7765 3.00024 5.5 3.00024H1.5C1.224 3.00024 1 3.22474 1 3.50024V10.5002C1 10.7757 1.224 11.0002 1.5 11.0002H8.5C8.776 11.0002 9 10.7757 9 10.5002V6.50024C9 6.22424 9.2235 6.00024 9.5 6.00024C9.7765 6.00024 10 6.22424 10 6.50024V10.5002C10 11.3272 9.327 12.0002 8.5 12.0002Z"
                            fill="#607D8B"
                        />
                        <path
                            d="M8.64403 1.58929L4.68803 5.54529C4.65303 5.58029 4.62953 5.62479 4.61953 5.67279L4.26603 7.44079C4.24953 7.52279 4.27503 7.60779 4.33453 7.66679C4.38203 7.71429 4.44603 7.73979 4.51153 7.73979L4.56053 7.73479L6.32803 7.38129C6.37703 7.37179 6.42103 7.34779 6.45603 7.31279L10.412 3.35679L8.64403 1.58929Z"
                            fill="#42A5F5"
                        />
                        <path
                            d="M11.6339 0.365747C11.1464 -0.121753 10.3534 -0.121753 9.86644 0.365747L9.17444 1.05775L10.9419 2.82525L11.6339 2.13325C11.8699 1.89775 11.9999 1.58375 11.9999 1.24975C11.9999 0.915747 11.8699 0.601747 11.6339 0.365747Z"
                            fill="#42A5F5"
                        />
                        <path
                            d="M9.49994 6C9.22344 6 8.99994 6.224 8.99994 6.5V10.5C8.99994 10.7755 8.77594 11 8.49994 11H1.49994C1.36194 11 1.23694 10.944 1.14644 10.8535L0.439941 11.56C0.711441 11.832 1.08644 12 1.49994 12H8.49994C9.32694 12 9.99994 11.327 9.99994 10.5V6.5C9.99994 6.2235 9.77644 6 9.49994 6Z"
                            fill="#546D79"
                        />
                        <path
                            d="M9.52797 2.4726L4.33447 7.66609C4.38197 7.71359 4.44597 7.73909 4.51147 7.73909L4.56047 7.73409L6.32797 7.38059C6.37697 7.37109 6.42097 7.34709 6.45597 7.31209L10.412 3.35609L9.52797 2.4726Z"
                            fill="#3990D5"
                        />
                        <path
                            d="M11.634 0.36615L10.0585 1.94165L10.9425 2.82565L11.6345 2.13365C11.87 1.89815 12 1.58415 12 1.25015C12 0.91615 11.87 0.60215 11.634 0.36615Z"
                            fill="#3990D5"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0">
                          <rect width="12" height="12" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                  </v-btn>
                </template>
                 <div class="time-update-clendar">
                <DatetimePicker
                    dateIcon
                    timeIcon
                    v-model="myDate"
                    no-title
                    label="Lịch hẹn"
                    time-format="HH:mm:ss"
                    date-format="MM/dd/yyyy"
                    @input="updateAppointmentTime(listTutor.contactTutorPractice[0])"
                >
                  <template slot="dateIcon">
                    <v-icon
                    >mdi-calendar-range
                    </v-icon
                    >
                  </template>
                  <template slot="timeIcon">
                    <v-icon
                    >mdi-clock-outline
                    </v-icon
                    >
                  </template>
                </DatetimePicker>
                </div>
              </v-menu>
            </div>
          </th>
          <th
              style="white-space: nowrap"
              v-if="listTutor.contactTutorPractice[0].subjectId == 2"
              :style="[listTutor.contactTutorPractice[0].interviewStatus == 2 ? {'padding':'0 12px'} : '']"
          >
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 0"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="d-flex">
                    <svg
                        class="mr-2"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M8 0C8.32 0 8.53333 0.213333 8.53333 0.533333V2.66667C8.53333 2.98667 8.32 3.2 8 3.2C7.68 3.2 7.46667 2.98667 7.46667 2.66667V0.533333C7.46667 0.213333 7.68 0 8 0ZM8 12.8C8.32 12.8 8.53333 13.0133 8.53333 13.3333V15.4667C8.53333 15.7867 8.32 16 8 16C7.68 16 7.46667 15.7867 7.46667 15.4667V13.3333C7.46667 13.0133 7.68 12.8 8 12.8ZM12.8 8C12.8 7.68 13.0133 7.46667 13.3333 7.46667H15.4667C15.7867 7.46667 16 7.68 16 8C16 8.32 15.7867 8.53333 15.4667 8.53333H13.3333C13.0133 8.53333 12.8 8.32 12.8 8ZM0 8C0 7.68 0.213333 7.46667 0.533333 7.46667H2.66667C2.98667 7.46667 3.2 7.68 3.2 8C3.2 8.32 2.98667 8.53333 2.66667 8.53333H0.533333C0.213333 8.53333 0 8.32 0 8ZM13.6533 2.34667C13.8667 2.56 13.8667 2.88 13.6533 3.09333L12.16 4.58667C11.9467 4.8 11.6267 4.8 11.4133 4.58667C11.2 4.37333 11.2 4.05333 11.4133 3.84L12.9067 2.34667C13.12 2.13333 13.44 2.13333 13.6533 2.34667ZM4.58667 11.4133C4.8 11.6267 4.8 11.9467 4.58667 12.16L3.09333 13.6533C2.88 13.8667 2.56 13.8667 2.34667 13.6533C2.13333 13.44 2.13333 13.12 2.34667 12.9067L3.84 11.4133C4.05333 11.2 4.37333 11.2 4.58667 11.4133ZM11.4133 11.4133C11.6267 11.2 11.9467 11.2 12.16 11.4133L13.6533 12.9067C13.8667 13.12 13.8667 13.44 13.6533 13.6533C13.44 13.8667 13.12 13.8667 12.9067 13.6533L11.4133 12.16C11.2 11.9467 11.2 11.6267 11.4133 11.4133ZM2.34667 2.34667C2.56 2.13333 2.88 2.13333 3.09333 2.34667L4.58667 3.84C4.8 4.05333 4.8 4.37333 4.58667 4.58667C4.37333 4.8 4.05333 4.8 3.84 4.58667L2.34667 3.09333C2.13333 2.88 2.13333 2.56 2.34667 2.34667Z"
                          fill="#F2994A"
                      />
                    </svg>

                    <span class="font-weight-bold mr-2">Chờ Pv</span>
                  </div>
                  <v-dialog
                      :retain-focus="false"
                      max-width="800px"
                      ref="myDialog"
                      v-model="listTutor.showPopup"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          dark
                          v-bind="attrs"
                          height="24"
                          width="8"
                          v-on="on"
                          @click="
                          interviewPopup(listTutor.contactTutorPractice[0])
                        "
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <validation-observer ref="validator" v-slot="{ invalid }">
                        <v-card-title>
                          <span class="text-h5 mr-2 header-popup-interview"
                          >Thông tin phỏng vấn</span
                          >
                        </v-card-title>
                        <v-card-text>
                          <v-divider class="mb-5"></v-divider>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Người phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn người phỏng vấn"
                                >
                                  <v-combobox
                                      :items="listInterview"
                                      required
                                      :error-messages="errors"
                                      item-text="fullName"
                                      item-value="id"
                                      dense
                                      placeholder="--Chọn chuyên môn--"
                                      outlined
                                      v-model="filterInterview.interviewUserId"
                                  ></v-combobox>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" sm="6">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Trạng thái phỏng vấn
                                  <span style="color: red">(*)</span>
                                </label>
                                <validation-provider
                                    v-slot="{ errors }"
                                    rules="required"
                                    name="Chọn trạng thái phỏng vấn"
                                >
                                  <v-select
                                      :items="allStatus.interviewStatus"
                                      class="mr-3"
                                      :error-messages="errors"
                                      item-value="value"
                                      item-text="text"
                                      placeholder="Chờ phỏng vấn"
                                      outlined
                                      dense
                                      v-model="filterInterview.interviewStatus"
                                  ></v-select>
                                </validation-provider>
                              </v-col>
                              <v-col cols="12" md="12">
                                <label
                                    for=""
                                    style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                                >Nhận xét
                                </label>
                                <v-textarea
                                    autocomplete="email"
                                    outlined
                                    v-model="filterInterview.interviewComment"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex">
                          <v-spacer></v-spacer>
                          <v-btn
                              text
                              rounded
                              outlined
                              class="btn-interview"
                              @click="closeMyDialog(listTutor)"
                          >
                            Đóng
                          </v-btn>
                          <v-btn
                              text
                              rounded
                              :disabled="invalid"
                              outlined
                              class="btn-interview"
                              @click="actionInterViewSave(listTutor)"
                          >
                            Lưu lại
                          </v-btn>
                        </v-card-actions>
                      </validation-observer>
                    </v-card>
                  </v-dialog>
                </div>
              
              </div>
            </template>

            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 3"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="">
                    <v-icon
                        color="#6F7782"
                        style="font-size: 16px; margin-right: 6px; color: #6f7782"
                    >
                      mdi-check-circle
                    </v-icon>
                    <span class="font-weight-bold mr-2">Đã Pv</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showPopup"
                      persistent
                      max-width="800px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          icon
                          color="#2F80ED"
                          dark
                          height="24"
                          width="8"
                          v-bind="attrs"
                          v-on="on"
                          @click="
                          interviewPopup(listTutor.contactTutorPractice[0])
                        "
                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>

                      <v-card-title>
                          <span class="text-h5 mr-2 header-popup-interview"
                          >Thông tin phỏng vấn</span
                          >
                      </v-card-title>
                      <v-card-text>
                        <v-divider class="mb-5"></v-divider>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                              >Người phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn người phỏng vấn"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    required
                                    :error-messages="errors"
                                    item-text="fullName"
                                    item-value="id"
                                    dense
                                    placeholder="--Chọn chuyên môn--"
                                    outlined
                                    v-model="filterInterview.interviewUserId"
                                ></v-combobox>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                              >Trạng thái phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn trạng thái phỏng vấn"
                              >
                                <v-select
                                    :items="allStatus.interviewStatus"
                                    class="mr-3"
                                    :error-messages="errors"
                                    item-value="value"
                                    item-text="text"
                                    placeholder="Chờ phỏng vấn"
                                    outlined
                                    dense
                                    v-model="filterInterview.interviewStatus"
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" md="12">
                              <label
                                  for=""
                                  style="
                                    color: #000000;
                                    font-size: 16px;
                                    font-weight: normal;
                                  "
                              >Nhận xét
                              </label>
                              <v-textarea
                                  autocomplete="email"
                                  outlined
                                  v-model="filterInterview.interviewComment"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            rounded
                            outlined
                            class="btn-interview"
                            @click="closeMyDialog(listTutor)"
                        >
                          Đóng
                        </v-btn>
                        <v-btn
                            text
                            rounded
                            outlined
                            disabled
                            class="btn-interview"
                            @click="actionInterViewSave(listTutor)"
                        >
                          Lưu lại
                        </v-btn>
                      </v-card-actions>

                    </v-card>
                  </v-dialog>
                </div>
               
              </div>
            </template>
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 2"
            >
              <div class="text-center">
                <v-dialog
                    v-model="listTutor.showPopup"
                    persistent
                    max-width="800px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        color="#2F80ED"
                        width="100"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        @click="interviewPopup(listTutor.contactTutorPractice[0])"
                    >
                      Chọn người Pv
                    </v-btn>
                  </template>
                  <v-card>
                    <validation-observer ref="validator" v-slot="{ invalid }">
                      <v-card-title>
                        <span class="text-h5 mr-2 header-popup-interview"
                        >Thông tin phỏng vấn</span
                        >
                      </v-card-title>
                      <v-card-text>
                        <v-divider class="mb-5"></v-divider>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                  color: #000000;
                                  font-size: 16px;
                                  font-weight: normal;
                                "
                              >Người phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn người phỏng vấn"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    required
                                    :error-messages="errors"
                                    item-text="fullName"
                                    item-value="id"
                                    dense
                                    placeholder="--Chọn chuyên môn--"
                                    outlined
                                    v-model="filterInterview.interviewUserId"
                                ></v-combobox>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" sm="6">
                              <label
                                  for=""
                                  style="
                                  color: #000000;
                                  font-size: 16px;
                                  font-weight: normal;
                                "
                              >Trạng thái phỏng vấn
                                <span style="color: red">(*)</span>
                              </label>
                              <validation-provider
                                  v-slot="{ errors }"
                                  rules="required"
                                  name="Chọn trạng thái phỏng vấn"
                              >
                                <v-select
                                    :items="allStatus.interviewStatus"
                                    class="mr-3"
                                    :error-messages="errors"
                                    item-value="value"
                                    item-text="text"
                                    placeholder="Chờ phỏng vấn"
                                    outlined
                                    dense
                                    v-model="filterInterview.interviewStatus"
                                ></v-select>
                              </validation-provider>
                            </v-col>
                            <v-col cols="12" md="12">
                              <label
                                  for=""
                                  style="
                                  color: #000000;
                                  font-size: 16px;
                                  font-weight: normal;
                                "
                              >Nhận xét
                              </label>
                              <v-textarea
                                  autocomplete="email"
                                  outlined
                                  v-model="filterInterview.interviewComment"
                              ></v-textarea>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions class="d-flex">
                        <v-spacer></v-spacer>
                        <v-btn
                            text
                            rounded
                            outlined
                            class="btn-interview"
                            @click="closeMyDialog(listTutor)"
                        >
                          Đóng
                        </v-btn>
                        <v-btn
                            text
                            rounded
                            :disabled="invalid"
                            outlined
                            class="btn-interview"
                            @click="actionInterViewSave(listTutor)"
                        >
                          Lưu lại
                        </v-btn>
                      </v-card-actions>
                    </validation-observer>
                  </v-card>
                </v-dialog>
              </div>
            </template>
            <template
                v-if="listTutor.contactTutorPractice[0].interviewStatus == 1"
            >
              <div style="text-align:left">
                <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                      d="M7.05002 5.99998L11.5 1.54998C11.8 1.24998 11.8 0.799976 11.5 0.499976C11.2 0.199976 10.75 0.199976 10.45 0.499976L6.00002 4.94998L1.55002 0.449976C1.25002 0.149976 0.800024 0.149976 0.500024 0.449976C0.200024 0.749976 0.200024 1.19998 0.500024 1.49998L4.95002 5.94998L0.500024 10.4C0.200024 10.7 0.200024 11.15 0.500024 11.45C0.650024 11.6 0.850024 11.65 1.05002 11.65C1.25002 11.65 1.45002 11.6 1.60002 11.45L6.05002 6.99998L10.5 11.45C10.65 11.6 10.85 11.65 11.05 11.65C11.25 11.65 11.45 11.6 11.6 11.45C11.9 11.15 11.9 10.7 11.6 10.4L7.05002 5.99998Z"
                      fill="#EB5757"
                  />
                </svg>
                <strong> Hủy </strong>
              </div>
            </template>
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].subjectId == 1"
              class="crossed"
              id="crossed"
          ></th>
          <th style="width: 150px;white-space: nowrap;">
            <div
                v-if="listTutor.contactTutorPractice[0].subjectId"
                class="d-flex justify-space-between"
                style="position: relative"
            >
              <div
                  class="d-flex justify-center flex-column"
              >
                <a :href="!listTutor.contactTutorPractice[0].testResult ? `${listTutor.contactTutorPractice[0].testLink}` : ''" 
                style="margin-bottom: 2px" class="mr-4"
                :style="[!listTutor.contactTutorPractice[0].testResult ? {'color':'blue'} : {'color':'#333333','text-decoration':'unset'} ]"
                >
                  {{
                    getSubjectTitle(listTutor.contactTutorPractice[0].subjectId)
                  }}
                </a>
              </div>
            </div>
            <div v-else>
              <p style="margin-bottom: 2px; color: #e0e0e0">Chưa chọn</p>
              <v-icon class="mdi-icon-edit">mdi-square-edit-outline</v-icon>
            </div>
          </th>
          <th
              v-if="listTutor.contactTutorPractice[0].testResult"
              style="white-space: nowrap;position:relative"
          >
            <div class="d-flex">
              <div></div>
              <strong>{{
                  listTutor.contactTutorPractice[0].testResult
                }}</strong>
              <a
                  :href="listTutor.contactTutorPractice[0].statusLink"
                  target="_blank"
                  style="text-decoration: unset;position:absolute;right: 0"
              >
                <v-icon class="mr-2" style="color: #0a4eaf;font-size:16px"
                >mdi-information
                </v-icon>
              </a
              >
            </div>
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>
          <th v-if="listTutor.contactTutorPractice[0].testResult" style="position:relative">
            <div
                v-if="listTutor.contactTutorPractice[0].commentStatus == 1"
                style="white-space: nowrap"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="d-flex align-center">
                    <svg style="margin-right: 6px; color: #6f7782" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8C16 12.4 12.4 16 8 16ZM8 1C4.15 1 1 4.15 1 8C1 11.85 4.15 15 8 15C11.85 15 15 11.85 15 8C15 4.15 11.85 1 8 1ZM11.4 6.45C11.6 6.25 11.6 5.95 11.4 5.75C11.2 5.55 10.9 5.55 10.7 5.75L6.4 10.05L4.85 8.5C4.65 8.3 4.3 8.3 4.15 8.5C4 8.7 4 9 4.15 9.2L6.05 11.1C6.25 11.3 6.55 11.3 6.75 11.1L11.4 6.45Z" fill="#6F7782"/>
                    </svg>
                    <span class="font-weight-bold">Đã nhận xét</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showDialog"
                      width="1170"
                      persistent
                      :retain-focus="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          @click="
                          getDetailComment(listTutor.contactTutorPractice[0].id)
                        "
                          icon
                          dark
                          height="24"
                          v-bind="attrs"
                          v-on="on"
                          style="position:absolute;right:0"

                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card v-if="detailComment">
                      <v-card-title
                          class="
                          text-h5 text-left
                          font-weight-700
                          button
                          text-uppercase
                          pt-6
                          pb-6
                        "
                          style="
                          color: #3cbac7;
                          background: white;
                          font-weight: bold;
                        "
                      >
                        TẠO PHIẾU NHẬN XÉT MÔN TOÁN
                        <v-row>
                          <v-col cols="12" md="7" class="">
                            <v-card
                                v-if="detailComment"
                                color=""
                                class="mt-5"
                                outline
                                width="697"
                                style="
                                border: 0.25px solid #00a86a;
                                box-shadow: unset;
                              "
                            >
                              <v-list-item three-line>
                                <v-list-item-avatar
                                    class="rounded-circle"
                                    tile
                                    size="80"
                                    color="grey"
                                >
                                  <v-img src="logo.png"></v-img
                                  >
                                </v-list-item-avatar>
                                <v-list-item-content>
                                  <div
                                      class="mb-2"
                                      style="
                                      color: #006e46;
                                      font-size: 16px;
                                      text-transform: capitalize
                                      font-weight: 500;
                                    "
                                  >
                                    {{ listTutor.userName }}
                                   
                                  </div>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="
                                      color: #4e4b66 !important;
                                      font-weight: 500;
                                    "
                                  >
                                    <!-- Ngày sinh: {{ detailComment.birthday }} -->
                                  </v-list-item-title>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66; font-weight: 500"
                                  >
                                    Số điện thoại: {{ listTutor.mobile }}
                                  </v-list-item-title>
                                  <v-list-item-title
                                      class="text-h5 mb-1 text-capitalize body-1"
                                      style="color: #4e4b66; font-weight: 500"
                                  >
                                    Ngày kiểm tra: {{ detailComment.do_practice_date }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </v-card>
                            <h4
                                class="mt-5"
                                style="color: #333333; text-transform: initial"
                            >
                              Nhận xét từ giáo viên
                            </h4>
                            <v-divider width="171"></v-divider>
                            <v-combobox
                                :items="listInterview"
                                label="Chọn người nhận xét"
                                dense
                                outlined
                                item-value="id"
                                item-text="fullName"
                                v-model="comments.commentBy"
                                class="mt-4 text-capitalize"
                                style="width: 200px"
                            ></v-combobox>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <vue-editor
                                  v-model="comments.commentContent"
                              ></vue-editor>
                              <span
                                  class="required-text"
                                  v-if="errors[0] && errors[0].length > 0"
                              >
                                {{ errors[0] }}
                              </span>
                            </validation-provider>
                            <h4
                                class="mt-5"
                                style="color: #333333; text-transform: initial"
                            >
                              Lộ trình học tập
                            </h4>
                            <v-divider width="171" class="mb-4"></v-divider>
                            <validation-provider
                                v-slot="{ errors }"
                                name="Nội dung"
                                rules="required"
                            >
                              <vue-editor
                                  v-model="comments.commentLearningPath"
                              ></vue-editor>
                              <span
                                  class="required-text"
                                  v-if="errors[0] && errors[0].length > 0"
                              >
                                {{ errors[0] }}
                              </span>
                            </validation-provider>
                          </v-col>
                          <v-col class="12" md="5" v-if="detailComment">
                            <v-row class="justify-center">
                              <div class="d-flex justify-center align-center">
                                <svg
                                    width="60"
                                    height="60"
                                    viewBox="0 0 60 60"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                      width="60"
                                      height="60"
                                      rx="16"
                                      fill="#FDD5D7"
                                  />
                                  <path
                                      d="M39.6836 19.15V20.3833L33.7836 16.9667C31.5502 15.6833 28.4336 15.6833 26.2169 16.9667L20.3169 20.4V19.15C20.3169 15.4 22.3669 13.3333 26.1169 13.3333H33.8836C37.6336 13.3333 39.6836 15.4 39.6836 19.15Z"
                                      fill="#FD3C4A"
                                  />
                                  <path
                                      d="M39.7335 23.2833L39.5002 23.1667L37.2335 21.8667L32.5335 19.15C31.1002 18.3167 28.9002 18.3167 27.4668 19.15L22.7668 21.85L20.5002 23.1833L20.2002 23.3333C17.2835 25.3 17.0835 25.6667 17.0835 28.8167V36.35C17.0835 39.5 17.2835 39.8667 20.2668 41.8833L27.4668 46.0333C28.1835 46.4667 29.0835 46.65 30.0002 46.65C30.9002 46.65 31.8168 46.45 32.5335 46.0333L39.8002 41.8333C42.7335 39.8667 42.9168 39.5167 42.9168 36.35V28.8167C42.9168 25.6667 42.7168 25.3 39.7335 23.2833ZM34.6502 32.5L33.6335 33.75C33.4668 33.9333 33.3502 34.2833 33.3668 34.5333L33.4668 36.1333C33.5335 37.1167 32.8335 37.6167 31.9168 37.2667L30.4335 36.6667C30.2002 36.5833 29.8168 36.5833 29.5835 36.6667L28.1002 37.25C27.1835 37.6167 26.4835 37.1 26.5502 36.1167L26.6502 34.5167C26.6668 34.2667 26.5502 33.9167 26.3835 33.7333L25.3502 32.5C24.7168 31.75 25.0002 30.9167 25.9502 30.6667L27.5002 30.2667C27.7502 30.2 28.0335 29.9667 28.1668 29.7667L29.0335 28.4333C29.5668 27.6 30.4168 27.6 30.9668 28.4333L31.8335 29.7667C31.9668 29.9833 32.2668 30.2 32.5002 30.2667L34.0502 30.6667C35.0002 30.9167 35.2835 31.75 34.6502 32.5Z"
                                      fill="#FD3C4A"
                                  />
                                </svg>

                                <h1
                                    class="text-lowercase ml-4"
                                    style="color: #fd3c4a"
                                >
                                  {{ testScore }}/10 điểm
                                </h1>
                              </div>
                              <div class="chartis-tutor-color">
                                <chartist
                                    ratio="ct-major-second"
                                    type="Bar"
                                    :data="chartData"
                                    :options="chartOptions"
                                    ref="my_chart"
                                >
                                </chartist>
                              </div>
                            </v-row>
                            <div
                                class="d-flex align-center justify-center mt-3"
                            >
                              <div class="d-flex align-center mr-8">
                                <v-sheet
                                    color="#00BA61"
                                    height="15"
                                    width="15"
                                    class="mr-2"
                                ></v-sheet>
                                <span class="shape-color">Số câu đúng</span>
                              </div>
                              <div class="d-flex align-center">
                                <v-sheet
                                    color="#FF3F3F"
                                    height="15"
                                    width="15"
                                    class="mr-2"
                                ></v-sheet>
                                <span class="shape-color">Số câu sai</span>
                              </div>
                            </div>
                            <div class="d-flex justify-center mt-3">
                              <v-btn
                                  color="#2F80ED"
                                  rounded
                                  outlined
                                  width="84"
                                  height="28"
                                  style="font-size: 10px"
                              >
                                <a
                                    v-if="detailComment"
                                    :href="detailComment.result_link"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style="text-decoration: unset; color: #2f80ed"
                                >Link chi tiết KQ</a
                                >
                              </v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-title>

                      <v-divider></v-divider>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="#00A854"
                            outlined
                            height="34"
                            width="127"
                            style="border-radius: 42px"
                            @click="
                            listTutor.showDialog = false;
                            removeChartElement();
                          "
                        >
                          Bỏ qua
                        </v-btn>
                        <v-btn
                            color="#00A854"
                            disabled
                            @click="
                            createComment(listTutor.contactTutorPractice[0].id)
                          "
                            height="34"
                            width="127"
                            style="border-radius: 42px"
                        >
                          Lưu lại
                        </v-btn>
                        <v-snackbar v-model="snackbarComment">
                          Comment đã được lưu lại

                          <template v-slot:action="{ attrs }">
                            <v-btn
                                color="blue"
                                text
                                v-bind="attrs"
                                @click="snackbarComment = false"
                            >
                              Close
                            </v-btn>
                          </template>
                        </v-snackbar>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
            <div
                v-if="listTutor.contactTutorPractice[0].commentStatus == 0"
                style="white-space: nowrap"
            >
              <div
                  class="d-flex justify-space-between flex-column"
              >
                <div
                    class="d-flex justify-space-between align-center pl-1 pr-1"
                >
                  <div class="">
                    <svg
                        style="margin-right: 6px"
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                          d="M8 0C8.32 0 8.53333 0.213333 8.53333 0.533333V2.66667C8.53333 2.98667 8.32 3.2 8 3.2C7.68 3.2 7.46667 2.98667 7.46667 2.66667V0.533333C7.46667 0.213333 7.68 0 8 0ZM8 12.8C8.32 12.8 8.53333 13.0133 8.53333 13.3333V15.4667C8.53333 15.7867 8.32 16 8 16C7.68 16 7.46667 15.7867 7.46667 15.4667V13.3333C7.46667 13.0133 7.68 12.8 8 12.8ZM12.8 8C12.8 7.68 13.0133 7.46667 13.3333 7.46667H15.4667C15.7867 7.46667 16 7.68 16 8C16 8.32 15.7867 8.53333 15.4667 8.53333H13.3333C13.0133 8.53333 12.8 8.32 12.8 8ZM0 8C0 7.68 0.213333 7.46667 0.533333 7.46667H2.66667C2.98667 7.46667 3.2 7.68 3.2 8C3.2 8.32 2.98667 8.53333 2.66667 8.53333H0.533333C0.213333 8.53333 0 8.32 0 8ZM13.6533 2.34667C13.8667 2.56 13.8667 2.88 13.6533 3.09333L12.16 4.58667C11.9467 4.8 11.6267 4.8 11.4133 4.58667C11.2 4.37333 11.2 4.05333 11.4133 3.84L12.9067 2.34667C13.12 2.13333 13.44 2.13333 13.6533 2.34667ZM4.58667 11.4133C4.8 11.6267 4.8 11.9467 4.58667 12.16L3.09333 13.6533C2.88 13.8667 2.56 13.8667 2.34667 13.6533C2.13333 13.44 2.13333 13.12 2.34667 12.9067L3.84 11.4133C4.05333 11.2 4.37333 11.2 4.58667 11.4133ZM11.4133 11.4133C11.6267 11.2 11.9467 11.2 12.16 11.4133L13.6533 12.9067C13.8667 13.12 13.8667 13.44 13.6533 13.6533C13.44 13.8667 13.12 13.8667 12.9067 13.6533L11.4133 12.16C11.2 11.9467 11.2 11.6267 11.4133 11.4133ZM2.34667 2.34667C2.56 2.13333 2.88 2.13333 3.09333 2.34667L4.58667 3.84C4.8 4.05333 4.8 4.37333 4.58667 4.58667C4.37333 4.8 4.05333 4.8 3.84 4.58667L2.34667 3.09333C2.13333 2.88 2.13333 2.56 2.34667 2.34667Z"
                          fill="#F2994A"
                      />
                    </svg>

                    <span class="font-weight-bold">Chờ nhận xét</span>
                  </div>
                  <v-dialog
                      v-model="listTutor.showDialog"
                      width="1170"
                      persistent
                      :retain-focus="false"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                          @click="
                          getDetailComment(listTutor.contactTutorPractice[0].id)
                        "
                          icon
                          dark
                          v-bind="attrs"
                          v-on="on"
                          style="position:absolute;right:0"

                      >
                        <v-icon style="color: #0a4eaf;font-size:16px">mdi-information</v-icon>
                      </v-btn>
                    </template>
                    <v-card>
                      <validation-observer ref="validator" v-slot="{ invalid }">
                        <v-card-title
                            class="
                            text-h5 text-left
                            font-weight-700
                            button
                            text-uppercase
                            pt-6
                            pb-6
                          "
                            style="
                            color: #3cbac7;
                            background: white;
                            font-weight: bold;
                          "
                        >
                          TẠO PHIẾU NHẬN XÉT MÔN TOÁN
                          <v-row>
                            <v-col cols="12" md="7" class="">
                              <v-card
                                  v-if="detailComment"
                                  color=""
                                  class="mt-5"
                                  elevation="1"
                                  outline
                                  width="697"
                              >
                                <v-list-item three-line>
                                  <v-list-item-avatar
                                      class="rounded-circle"
                                      tile
                                      size="80"
                                      color="grey"
                                  >
                                    <v-img src="logo.png"></v-img
                                    >
                                  </v-list-item-avatar>
                                  <v-list-item-content>
                                    <div
                                        class="mb-2"
                                        style="
                                        color: #006e46;
                                        font-size: 16px;
                                        text-transform: capitalize;
                                      "
                                    >
                                      {{ detailComment.student_name }}
                                     
                                    </div>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Ngày sinh: {{ detailComment.birthday }}
                                    </v-list-item-title>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Số điện thoại: {{ listTutor.mobile }}
                                    </v-list-item-title>
                                    <v-list-item-title
                                        class="
                                        text-h5
                                        mb-1
                                        text-capitalize
                                        body-1
                                      "
                                        style="color: #4e4b66"
                                    >
                                      Ngày kiểm tra: {{ detailComment.do_practice_date }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-card>
                              <h4
                                  class="mt-5"
                                  style="color: #333333; text-transform: initial"
                              >
                                Nhận xét từ giáo viên
                              </h4>
                              <v-divider width="171"></v-divider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Người nhận xét"
                                  rules="required"
                              >
                                <v-combobox
                                    :items="listInterview"
                                    label="Chọn người nhận xét"
                                    :error-messages="errors"
                                    dense
                                    outlined
                                    item-text="fullName"
                                    item-value="id"
                                    v-model="comments.commentBy"
                                    class="mt-4 text-capitalize"
                                    style="width: 200px"
                                ></v-combobox>
                              </validation-provider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Nội dung"
                                  rules="required"
                              >
                                <vue-editor
                                    v-model="comments.commentContent"
                                ></vue-editor>
                                <span
                                    class="required-text"
                                    v-if="errors[0] && errors[0].length > 0"
                                >
                                  {{ errors[0] }}
                                </span>
                              </validation-provider>
                              <h4
                                  class="mt-5"
                                  style="color: #333333; text-transform: initial"
                              >
                                Lộ trình học tập
                              </h4>
                              <v-divider width="171" class="mb-4"></v-divider>
                              <validation-provider
                                  v-slot="{ errors }"
                                  name="Nội dung"
                                  rules="required"
                              >
                                <vue-editor
                                    v-model="comments.commentLearningPath"
                                ></vue-editor>
                                <span
                                    class="required-text"
                                    v-if="errors[0] && errors[0].length > 0"
                                >
                                  {{ errors[0] }}
                                </span>
                              </validation-provider>
                            </v-col>
                            <v-col class="12" md="5" v-if="detailComment">
                              <v-row class="justify-center">
                                <div class="d-flex justify-center align-center">
                                  <svg
                                      width="60"
                                      height="60"
                                      viewBox="0 0 60 60"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <rect
                                        width="60"
                                        height="60"
                                        rx="16"
                                        fill="#FDD5D7"
                                    />
                                    <path
                                        d="M39.6836 19.15V20.3833L33.7836 16.9667C31.5502 15.6833 28.4336 15.6833 26.2169 16.9667L20.3169 20.4V19.15C20.3169 15.4 22.3669 13.3333 26.1169 13.3333H33.8836C37.6336 13.3333 39.6836 15.4 39.6836 19.15Z"
                                        fill="#FD3C4A"
                                    />
                                    <path
                                        d="M39.7335 23.2833L39.5002 23.1667L37.2335 21.8667L32.5335 19.15C31.1002 18.3167 28.9002 18.3167 27.4668 19.15L22.7668 21.85L20.5002 23.1833L20.2002 23.3333C17.2835 25.3 17.0835 25.6667 17.0835 28.8167V36.35C17.0835 39.5 17.2835 39.8667 20.2668 41.8833L27.4668 46.0333C28.1835 46.4667 29.0835 46.65 30.0002 46.65C30.9002 46.65 31.8168 46.45 32.5335 46.0333L39.8002 41.8333C42.7335 39.8667 42.9168 39.5167 42.9168 36.35V28.8167C42.9168 25.6667 42.7168 25.3 39.7335 23.2833ZM34.6502 32.5L33.6335 33.75C33.4668 33.9333 33.3502 34.2833 33.3668 34.5333L33.4668 36.1333C33.5335 37.1167 32.8335 37.6167 31.9168 37.2667L30.4335 36.6667C30.2002 36.5833 29.8168 36.5833 29.5835 36.6667L28.1002 37.25C27.1835 37.6167 26.4835 37.1 26.5502 36.1167L26.6502 34.5167C26.6668 34.2667 26.5502 33.9167 26.3835 33.7333L25.3502 32.5C24.7168 31.75 25.0002 30.9167 25.9502 30.6667L27.5002 30.2667C27.7502 30.2 28.0335 29.9667 28.1668 29.7667L29.0335 28.4333C29.5668 27.6 30.4168 27.6 30.9668 28.4333L31.8335 29.7667C31.9668 29.9833 32.2668 30.2 32.5002 30.2667L34.0502 30.6667C35.0002 30.9167 35.2835 31.75 34.6502 32.5Z"
                                        fill="#FD3C4A"
                                    />
                                  </svg>

                                  <h1
                                      class="text-lowercase ml-4"
                                      style="color: #fd3c4a"
                                  >
                                    {{ testScore }}/10 điểm
                                  </h1>
                                </div>
                                <div class="chartis-tutor-color">
                                  <chartist
                                      ratio="ct-major-second"
                                      type="Bar"
                                      :data="chartData"
                                      :options="chartOptions"
                                      ref="my_chart"
                                  >
                                  </chartist>
                                </div>
                              </v-row>
                              <div
                                  class="d-flex align-center justify-center mt-3"
                              >
                                <div class="d-flex align-center mr-8">
                                  <v-sheet
                                      color="#00BA61"
                                      height="15"
                                      width="15"
                                      class="mr-2"
                                  ></v-sheet>
                                  <span class="shape-color">Số câu đúng</span>
                                </div>
                                <div class="d-flex align-center">
                                  <v-sheet
                                      color="#FF3F3F"
                                      height="15"
                                      width="15"
                                      class="mr-2"
                                  ></v-sheet>
                                  <span class="shape-color">Số câu sai</span>
                                </div>
                              </div>
                              <div class="d-flex justify-center mt-3">
                                <v-btn
                                    color="#2F80ED"
                                    rounded
                                    outlined
                                    width="84"
                                    height="28"
                                    style="font-size: 10px"
                                >
                                  <a
                                      v-if="detailComment"
                                      :href="detailComment.result_link"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style="
                                      text-decoration: unset;
                                      color: #2f80ed;
                                    "
                                  >Link chi tiết KQ</a
                                  >
                                </v-btn>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-title>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                              color="#00A854"
                              outlined
                              height="34"
                              width="127"
                              style="border-radius: 42px"
                              @click="
                              listTutor.showDialog = false;
                              removeChartElement();
                            "
                          >
                            Bỏ qua
                          </v-btn>
                          <v-btn
                              color="#00A854"
                              :disabled="invalid"
                              @click="
                              createComment(
                                listTutor.contactTutorPractice[0].id
                              )
                            "
                              height="34"
                              width="127"
                              style="border-radius: 42px"
                          >
                            Lưu lại
                          </v-btn>
                          <v-snackbar v-model="snackbarComment">
                            Comment đã được lưu lại

                            <template v-slot:action="{ attrs }">
                              <v-btn
                                  color="blue"
                                  text
                                  v-bind="attrs"
                                  @click="snackbarComment = false"
                              >
                                Close
                              </v-btn>
                            </template>
                          </v-snackbar>
                        </v-card-actions>
                      </validation-observer>
                    </v-card>
                  </v-dialog>
                </div>
              </div>
            </div>
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>

          <th
              v-if="listTutor.contactTutorPractice[0].order != null"
              style="font-weight: 700"
          >
            {{ listTutor.contactTutorPractice[0].order.code }}
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>
          <th v-if="listTutor.contactTutorPractice[0].order != null">
            <div v-for="status in allStatus.orderStatus" :key="status.id">
              <div
                  v-if="
                  listTutor.contactTutorPractice[0].order.statusId == status.id
                "
              >
                {{ status.text }}
              </div>
            </div>
          </th>
          <th v-else style="color:#E0E0E0;font-size:font-size: 14px">
            Chưa có
          </th>
          <!-- <th>
            <div>
              <v-icon class="mdi-icon-phone" style="color: rgb(103, 173, 91)"
                >mdi-phone</v-icon
              >
              <v-icon class="mdi-icon-pencil" style="color: rgb(215, 56, 100)"
                >mdi-pencil</v-icon
              >


              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="
                      clickExecuteCall(listTutor, listTutor.mobile)
                    "
                    class="mr-1"
                    icon
                    small
                    color="success"
                    v-on="on"
                  >
                    <v-icon>mdi-phone</v-icon>
                  </v-btn>
                </template>
                <span>Gọi cho khách hàng</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mr-1"
                    @click="clickContact(listTutor)"
                    icon
                    small
                    color="rgb(215, 56, 100)"
                    v-on="on"
                  >
                    <v-icon size="16">mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>Cập nhật thông tin khách hàng</span>
              </v-tooltip>
            </div>
          </th> -->
        </tr>
      </template>
    </template>
    <v-snackbar v-model="snackbarComment" :timeout="+2000">
      Comment đã được lưu lại
    </v-snackbar>

    <v-snackbar v-model="snackbarInterview" :timeout="+2000">
      Lưu lại thành công

      <template v-slot:action="{ attrs }">
        <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="snackbarInterview = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </table>
</template>

<script>
import moment from "moment";
import TokenService from "../../../helpers/token";
import * as ChartistTooltips from "chartist-plugin-tooltips";
import RepositoryFactory from "../../../repositories/RepositoryFactory";

const ContactRepository = RepositoryFactory.get("contact");
const TestManageRepository = RepositoryFactory.get("testManage");
import DatetimePicker from "vuetify-datetime-picker/src/components/DatetimePicker";
import DateRangePicker from "../../../components/common/RangePicker.vue";
import DatePicker from "vue2-datepicker";
// import { Chart } from "highcharts-vue";
import {VueEditor} from "vue2-editor";

export default {
  components: {DatetimePicker},
  props: {
    periodReport: {
      default: () => ({}),
    },
    subjects: {
      type: Array,
    },
    listTutors: {
      type: Array,
      default: () => {
        [];
      },
    },
    listInterview: {
      type: Array,
    },
    allStatus: {
      type: Object,
    },
  },
  data() {
    return {
      showTimePickPopup:false,
      dialogInfo: false,
      dialog: false,
      chartData: {
        labels: [],
        series: [[], []],
      },
      chartOptions: {
        stackBars: true,
        width: "500px",
        height: "500px",
        axisY: {
          labelInterpolationFnc: function (value) {
            if (value % 1 == 0) {
              return value;
            }
          },
        },
        scale: {
          pointLabels: {
            fontStyle: "bold",
          },
        },
      },
      filterInterview: {
        tutorPracticeId: null,
        interviewUserId: null,
        interviewStatus: null,
        interviewComment: "",
      },
      comments: {
        commentContent: null,
        commentLearningPath: null,
        commentBy: "",
      },
      snackbarComment: false,
      snackbarTestLink: false,

      snackbarInterview: false,
      detailComment: null,
      dateRangeText: false,
      datePicker: false,
      myDate: null,
      updateDateTime: null,
    };
  },
  beforeCreate: function () {
    this.$options.components.DatetimePicker =
        require("vuetify-datetime-picker/src/components/DatetimePicker").default;
  },
  async created() {
  },
  components: {VueEditor},
  mounted() {
  },
  methods: {
    async interviewPopup(interview) {
      this.filterInterview.interviewUserId = null;
      this.filterInterview.interviewStatus = null
      this.filterInterview.interviewComment = null
      this.filterInterview.tutorPracticeId = interview.id;
      const allStatus = await TestManageRepository.getAllStatus();
      this.allStatus = allStatus.data;
      for (let j = 0; j < allStatus.data.length; j++) {
        this.allStatus.push(allStatus.data.contactTutorStatus[j].text);
      }
      if (interview.interviewComment) {
        this.filterInterview.interviewComment = interview.interviewComment
      }
      if (interview.interviewUser) {
        this.listInterview.filter((s) => {
          
          if (s.id == interview.interviewUser) {
            this.filterInterview.interviewUserId ={
              fullName:s.fullName,
              id:s.id
            }
          }
        });
      }
      if (interview.interviewStatus) {
        this.filterInterview.interviewStatus = interview.interviewStatus;
      }
    },
    async getDetailComment(id) {
      this.comments.commentContent = null
      this.comments.commentLearningPath = null
      const response = await TestManageRepository.getDetailComment(id);
      if (response.success) {
        this.detailComment = _.get(response, "data", []);
        if (this.detailComment.comment_teacher) {
          this.comments.commentContent = this.detailComment.comment_teacher;
        }
        if (this.detailComment.comment_study_journey) {
          this.comments.commentLearningPath =
              this.detailComment.comment_study_journey;
        }
        if (this.detailComment.comment_by) {
          // this.comments.commentBy = this.detailComment.comment_by;
          this.listInterview.filter((s) => {
            if (s.id == this.detailComment.comment_by) {
              this.comments.commentBy = s.fullName;
            }
          });
        }
        const A = [];
        const B = [];
        for (let i = 0; i < this.detailComment.section.length; i++) {
          let tongsocau = this.detailComment.section[i].total_question;
          let socaudung = this.detailComment.section[i].total_question_correct;
          A.push(socaudung);
          B.push(tongsocau - socaudung);
        }
        for (let j = 0; j < this.detailComment.section.length; j++) {
          this.chartData.labels.push(
              this.detailComment.section[j].section_name
          );
        }
        this.chartData.series[0] = A;
        this.chartData.series[1] = B;
        setTimeout(function () {
          window.dispatchEvent(new Event("resize"));
        }, 300);
      }
    },
    removeChartElement() {
      this.comments.commentContent = null
      this.comments.commentLearningPath = null
      this.comments.commentBy = null
      this.chartData.labels = [];
      if (this.$refs.my_chart[0]) {
        this.$refs.my_chart[0].$destroy();
      }
      if (this.$refs.my_chart[1]) {
        this.$refs.my_chart[1].$destroy();
      }

      // this.chartData.series[0] = [];
      // this.chartData.series[1] = [];
      // this.chartData.labels = [];
    },
    async getAllStatus() {
      const response = await TestManageRepository.getAllStatus();
      this.allStatus = response.data;
    },
    closeMyDialog(index) {
      // index.showDialog = false;
      index.showPopup = false;
    },
    async actionInterViewSave(index) {
      index.showPopup = false;

      const data = {
        interviewStatus: this.filterInterview.interviewStatus,
        interviewComment: this.filterInterview.interviewComment,
        interviewUser: this.filterInterview.interviewUserId.id,
      };
      const response = await TestManageRepository.createInterview(
          this.filterInterview.tutorPracticeId,
          data
      );
      if (response.success) {
        this.snackbarInterview = true;
        this.$router.go(this.$router.currentRoute);
      }
    },
    async createComment(id) {
      this.dialogInfo = false;
      const body = {
        commentBy: this.comments.commentBy.id,
        commentContent: this.comments.commentContent,
        commentLearningPath: this.comments.commentLearningPath,
      };
      const response = await TestManageRepository.createComment(id, body);
      if (response.success) {
        this.snackbarComment = true;
      }
    },
    timeUnitsBetween(startDate, endDate) {
      let status = "";
      let delta = Math.abs(endDate - startDate) / 1000;
      const isNegative = startDate > endDate ? -1 : 1;

      const remainDate = [
        ["days", 24 * 60 * 60],
        ["hours", 60 * 60],
        ["minutes", 60],
        ["seconds", 1],
      ].reduce(
          (acc, [key, value]) => (
              (acc[key] = Math.floor(delta / value) * isNegative),
                  (delta -= acc[key] * isNegative * value),
                  acc
          ),
          {}
      );
      remainDate.days < 1 && remainDate.hours < 1 && remainDate.minutes < 1
          ? (status = "Đã quá hạn")
          : (status = "Còn");
      return (
          status +
          " " +
          Math.abs(remainDate.days) +
          " ngày " +
          Math.abs(remainDate.hours) +
          " giờ " +
         Math.abs( remainDate.minutes) + " phút"
      );
    },
    async updateAppointmentTime(item) {
      item.showDate = false;
      const day = this.myDate.getDate();
      const month = this.myDate.getMonth() + 1;
      const year = this.myDate.getFullYear();
      const hour = this.myDate.getHours();
      const minutes = this.myDate.getMinutes();
      const second = this.myDate.getSeconds();
      const time =
          year +
          "-" +
          (month < 10 ? `0${month}` : month) +
          "-" +
          (day < 10 ? `0${day}` : day) +
          " " +
          (hour < 10 ? `0${hour}` : hour) +
          ":" +
          (minutes < 10 ? `0${minutes}` : minutes) +
          ":" +
          "00";
      this.updateDateTime = time;
      const params = {
        appointmentTime: time,
      };
      item.appointmentTime = _.cloneDeep(
          this.updateDateTime
      );
      const response = await TestManageRepository.updateDateTime(
          item.id,
          params
      );
    },

    showTime(time) {
      this.myDate = moment(time).format("YYYY-MM-DD");
    },
    getSubjectName(subjectId) {
      let index = this.subjects.findIndex((s) => s.id == subjectId);

      if (index > -1) {
        return this.subjects[index].title;
      }

      return "";
    },
    getStatusText(statusId) {
      let index = this.allStatus.orderStatus.findIndex((s) => s.id == statusId);

      if (index > -1) {
        return this.allStatus.orderStatus[index].text;
      }

      return "";
    },
    appointmenTimeText(time) {
      let alo = time.split(" ");
      var obj = {};
      return (obj = {
        date: alo[0].replace(/-/gi, "/"),
        time: alo[1].slice(0, 5),
      });
    },
    interviewBy(interviewId) {
      var fullName;

      this.listInterview.filter((s) => {
        if (s.id == interviewId) {
          fullName = s.fullName;
        }
      });

      return fullName;
    },
    interviewCommentBy(id) {
      var interviewUser;
      this.listInterview.filter((s) => {
        if (s.id == id) {
          interviewUser = s.fullName;
        }
      });
      return interviewUser;
    },
    getSubjectTitle(subjectId) {
      var subject;
      this.subjects.filter((s) => {
        if (s.id == subjectId) {
          subject = s.title;
        }
      });
      return subject;
    },
    clickExecuteCall(listTutor, phone) {
      let user = TokenService.getUser();
      if (user.ext) {
        if (listTutor.contactTutorPractice.length > 0) {
          let data = {
            mobile: phone,
            showCreateAppointment: false,
            callcenter_id: user.callcenter_id,
            contactId: listTutor.contactTutorPractice[0].contactId,
            mainMobile: phone
            // mainId: contact[0].mainId,
            // store: this.filterForm.store,
          };
          Bus.$emit("voice-call-show-popup", data);
        } else {
          this.$swal({
            title: "Lỗi!",
            text: "Không liên hệ được với số điện thoại này!",
          });
        }
      } else {
        this.$swal({
          title: "Lỗi!",
          text: "Chưa có máy lẻ. Vui lòng liên hệ Admin!",
        });
      }
    },
    clickContact(listTutor) {
      var contactId = '';

      if (listTutor.contactTutorPractice.length > 0) {
        contactId = listTutor.contactTutorPractice[0].contactId
      }
      let routeData = this.$router.resolve({
        name: "ContactDetail",
        params: {
          id: contactId || 0,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
  computed: {
    sections() {
      return this.detailComment.section.map((s) => {
        return s.section_name;
      });
    },
    testScore() {
      return (Math.round(this.detailComment.diem_thi * 100 )*10 / 100)
    },
  },
  watch: {
    deep: true,
    handler(newValue) {
      this.chart.update(newData);
    },
  },
};
</script>
<style  lang="scss">
@import '../../../sass/custom_chartist_color.scss';
</style>
<style scoped lang="scss">
.ct-tooltip {
  position: absolute;
  display: inline-block;
  min-width: 5em;
  padding: 8px 10px;
  background: #383838;
  color: #fff;
  text-align: center;
  pointer-events: none;
  z-index: 100;
  transition: opacity 0.2s linear;

  // Arrow
  &:before {
    position: absolute;
    bottom: -14px;
    left: 50%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    pointer-events: none;
    border-color: rgba(251, 249, 228, 0);
    border-top-color: #383838;
    border-width: 7px;
    margin-left: -8px;
  }

  &.hide {
    display: block;
    opacity: 0;
    visibility: hidden;
  }
}

th,
td {
  border: 1px solid #e0e0e0;
}

table {
  border-collapse: collapse;
  border: 0;
  width: 100%;
  // margin-bottom: 30px;
}

th {
  text-align: left;
  padding:12px;
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  height: 57px;
}

.th-boild {
  font-weight: 700;
}

.th-green {
  background: #e9f8ef;
}

.th-yellow {
  background: #fdf7e4;
}

.th-orange {
  background: #fbf0cd;
}

.th-blue {
  background: #dff0fa;
}

.mdi-icon-phone {
  color: #66ad5b;
}

.mdi-icon-pencil {
  color: #d63964;
}

.mdi-icon-edit {
  color: #42a5f5;
}

.small-text {
  font-size: 12px;
  margin-right: 8px;
}

.mdi-icon-check {
  font-size: 16px;
  margin-right: 6px;
  color: #25e8c8;
}

.btn-select-interview {
  margin-right: 0 !important;
  margin-bottom: 0 !important;
}

.box-test {
  width: 150px;
  height: 99px;
  background: #ffffff;

  border-radius: 6px;
  margin-top: 25px;
}

.mdi-icon-phone {
  color: #67ad5b;
}

.mdi-icon-pencil {
  color: #67ad5b;
}

.box-test span {
  color: #172b4d;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
}

#quill-container {
  height: 128px;
}
.ql-editor {
  text-transform: initial !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.crossed {
  background: linear-gradient(
          to top left,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) calc(50% - 0.8px),
          #e0e0e0 50%,
          rgba(0, 0, 0, 0) calc(50% + 0.8px),
          rgba(0, 0, 0, 0) 100%
  ),
  linear-gradient(
          to top right,
          rgba(0, 0, 0, 0) 0%,
          rgba(0, 0, 0, 0) calc(50% - 0.8px),
          #e0e0e0 50%,
          rgba(0, 0, 0, 0) calc(50% + 0.8px),
          rgba(0, 0, 0, 0) 100%
  );
}
th table th {
  border: none;
  border-bottom: 1px solid #e0e0e0;
}

th table tr {
  &:last-child {
    th {
      border-bottom: none;
    }
  }
}

.row-table:first-child {
  transform: translateY(-50%);
}

.row-table:not(:first-child) {
  transform: translateY(+50%);
}

.header-popup-interview {
  color: #333333;
  font-style: normal;
  font-weight: 500;
  font-size: 18px !important;
}

.btn-interview {
  color: #6e7191 !important;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
}

.required-text {
  color: red;
  text-transform: initial;
  font-size: 12px;
}

#app
> div.v-menu__content.theme--light.menuable__content__active
> div.v-input.v-input--is-readonly.theme--light.v-text-field.v-text-field--is-booted {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

#app
> div.v-menu__content.theme--light.menuable__content__active
> div.v-input.v-input--is-readonly.theme--light.v-text-field.v-text-field--is-booted
> div
> div.v-input__slot {
  margin-bottom: 0 !important;
}

#app
> div.v-menu__content.theme--light.menuable__content__active
> div.v-input.v-input--is-readonly.theme--light.v-text-field.v-text-field--is-booted
> div
> div.v-text-field__details {
  display: none !important;
}

#app
> div.v-menu__content.theme--light.menuable__content__active
> div.v-input.v-input--is-readonly.theme--light.v-text-field.v-text-field--is-booted {
  padding-top: 0 !important;
  margin-top: 0 !important;
}

.shape-color {
  font-size: 12px;
  text-transform: initial;
  font-weight: normal;
  color: #14142b;
}
.space-row{
  padding: 0 12px;
}
.topics tr { 
  line-height: 14px; 
  overflow: hidden;
  height: 14px;
  white-space: nowrap;
  }
  .update-time-btn{
    position: absolute;
    right: 0;
    top: -4px;
  }
  .interview-btn{
    position: absolute;
    right: 0;
  }
</style>
